import React, { useState, useEffect, useCallback } from "react";
import { Alert, Form, Row, Col, Button, FormFeedback, FormGroup, Label, Input, UncontrolledPopover, PopoverBody } from "reactstrap";
import { Link } from "react-router-dom";
import ConfigData from '../../../config.json';
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import SingleUploadfile from '../../common/single-uploadfile';
import MultipleUploadfile from '../../common/multiple-uploadfile';
import { setStringFileNameToArray, TransformColumnToArray } from '../../utils/format-value';
import { getDomain, getFillArray, ValidateNumber } from '../../utils/check-value';
// import { setSelectionRange } from "@testing-library/user-event/dist/utils";
import { IconAlertError, IconAlertReturn } from '../../../components/common/popup-alert';

const RequestFormLdr = ({ dataFormLdr, dataFormRequest, onSaveDraft, onSave, onCancelRequest}) => {
    const history = useHistory();
    const modelFormDocCert = { doc_cert_bu: '', doc_cert_bu_other: '', doc_cert_bu_expire: '', doc_cert_amount: '', is_bu_other: '0' };
    const modelFormDocPassport = { doc_passport_name: '', doc_passport_amount: '' };
    const modelFormDocIdCard = { doc_idcard_name: '', doc_idcard_amount: '' };
    const modelFormDocIdCardHouse = { doc_idcard_house_name: '', doc_idcard_house_amount: '' };
    const modelFormDocShareholders = { doc_shareholders_bu: '', doc_shareholders_bu_other: '', doc_shareholders_expire: '', doc_shareholders_amount: '', is_bu_other: '0' };
    const modelFormDocTaxBranch = { doc_tax_branch_name: '', doc_tax_branch_amount: '' };
    const modelFormDocOther = { doc_other_name: '', doc_other_expire: '', doc_other_amount: '', doc_other_reason: '' };
    const [dataDetail, setDataDetail] = useState([]);
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);
    const [emailLegalAuthorized , setEmailLegalAuthorized] = useState([]);
    const [emailLegalAdmin , setEmailLegalAdmin] = useState([]);
    const [formTemp, setFormTemp] = useState({});
    const [showCommentApprover, setShowCommentApprover] = useState(false);
    const userEmail = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
    const autoCompletes = "off";
    // Thailand is UTC+7
    const thaiTimezoneOffset = 7 * 60; 
    const offsetInMilliseconds = thaiTimezoneOffset * 60 * 1000;
    const thaiDateTime = new Date(new Date().getTime() + offsetInMilliseconds);
    // Format the date for MySQL DATETIME
    const newDateTime = thaiDateTime.toISOString().slice(0, 19).replace("T", " ");

    const [dataUser, setDataUser] = useState([]);

    //data from component group select
    const [fileForUseDoc, setFileForUseDoc] = useState([]);
    const [fileMemoDoc, setFileMemoDoc] = useState([]);
    const [selectIdBusinessUnit, setSelectIdBusinessUnit] = useState(null);
    const [selectDocCertBu, setSelectDocCertBu] = useState([null]);
    const [formDocCert, setFormDocCert] = useState(null);
    const [formIdCard, setFormIdCard] = useState(null);
    const [formIdCardHouse, setFormIdCardHouse] = useState(null);
    const [formPassport, setFormPassport] = useState(null);
    const [selectDocShareholderBu, setSelectDocShareholderBu] = useState([null]);
    const [formShareholders, setFormShareholders] = useState(null);
    const [formTaxBranchs, setFormTaxBranchs] = useState(null);
    const [formOther, setFormOther] = useState(null);
    const [dataCompany, setDataCompany] = useState([]);
    const [checkBoxDocCert, setCheckBoxDocCert] = useState("0"); 
    const [checkBoxIdCard, setCheckBoxIdCard] = useState("0");
    const [rdDocIsIdCardType, setRdDocIsIdCardType] = useState("");
    const [cbDocIdcardType, setCbDocIdcardType] = useState("0");
    const [cbDocIdcardHouseType, setCbDocIdcardHouseType] = useState("0");
    const [checkBoxPassport, setCheckBoxPassport] = useState("0"); 
    const [checkBoxShareholders, setCheckBoxShareholders] = useState("0"); 
    const [checkBoxTax, setCheckBoxTax] = useState("0");
    const [cbDocTaxHeadOfficeType, setCbDocTaxHeadOfficeType] = useState("0");
    const [cbDocTaxBranchType, setCbDocTaxBranchType] = useState("0");
    const [checkBoxOther, setCheckBoxOther] = useState("0"); 
    const [rdCertifiedTrueCopy, setRdCertifiedTrueCopy] = useState("");
    const [formIsDisabled, setFormIsDisabled] = useState(false);
    const [showReasonMoreOneCopy, setShowReasonMoreOneCopy] = useState(false);

    const englishEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const checkShowInputUserCoordinator = (
        (getDomain(userEmail) !== "btsgroup.co.th" || dataUser.business_unit?.toLowerCase() !== "bts group holdings public company limited") 
        && (dataFormLdr.id === 0 || dataFormRequest.request_no === "draft")
    );

    const checkUserIsApproverShowReturnBtn = (
        dataUser.email === dataFormRequest.approve_request_by && dataFormRequest.id_workflow_status !== 4
    );

    const changeButtonIsStateRequestorOrApprover = (
        (dataFormRequest.id_workflow_status !== 1 && dataFormRequest.id_workflow_status !== 2 && dataUser.email === dataFormRequest.request_by) 
        || (dataFormRequest.id_workflow_status !== 1 && dataFormRequest.id_workflow_status !== 2 && dataUser.email === dataFormRequest.create_request_by)
        || (dataFormRequest.id_workflow_status !== 4 && dataUser.email === dataFormRequest.approve_request_by) 
        || (dataFormLdr?.id === 0)
    );

    const checkUserCreateTicketAndApproveIsSame = ( 
        dataFormRequest.request_by !== dataFormRequest.approve_request_by
    );

    const checkAuthorizedReturn = (
        (dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by) 
        || (dataUser.id_user_group === 2) 
        || (dataFormRequest.id_workflow_status === 4)
    );

    const checkAuthorizedSubmitOrApprove = (
        (dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by) 
        || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
        || dataFormRequest.id_workflow_status === 4
    );
 
    useEffect(() => {
        LoadDataBusinessUnit();
        LoadProfileUser(userEmail);
        LoadLegalAdmin(5); // หมายถึง กลุ่มของ user admin
    }, []);

    useEffect(() => {
        if(dataFormLdr?.id > 0){
            if(dataFormLdr.reason_more_one_copy !== "" && dataFormLdr.reason_more_one_copy !== null){
                dataFormLdr.is_more_one_copy = "true";
            }else{
                dataFormLdr.is_more_one_copy = "false";
            }
            setSelectIdBusinessUnit(dataCompany.find(x => x.value === dataFormLdr.id_business_unit.toString()) ?? "");
            setDataDetail(dataFormLdr);        
            let arrFormDocCert = TransformColumnToArray(dataFormLdr, modelFormDocCert, 5);
            let arrFormDocPassport = TransformColumnToArray(dataFormLdr, modelFormDocPassport, 5);
            let arrFormDocIdCard = TransformColumnToArray(dataFormLdr, modelFormDocIdCard, 5);
            let arrFormDocIdCardHouse = TransformColumnToArray(dataFormLdr, modelFormDocIdCardHouse, 5);
            let arrFormDocShareholders = TransformColumnToArray(dataFormLdr, modelFormDocShareholders, 5);
            let arrFormDocTaxBranch = TransformColumnToArray(dataFormLdr, modelFormDocTaxBranch, 5);
            let arrFormDocOther = TransformColumnToArray(dataFormLdr, modelFormDocOther, 10);

            setCheckBoxDocCert(dataFormLdr.req_doc_cert);
            setFormDocCert(arrFormDocCert);
            if(arrFormDocCert !== null){
                setSelectDocCertBu(arrFormDocCert.map(item => { return dataCompany.find(x => x.value === item.doc_cert_bu.toString()) ?? ""; }));
            }
            setCheckBoxPassport(dataFormLdr.req_doc_passport);
            setFormPassport(arrFormDocPassport);
            setCheckBoxIdCard(dataFormLdr.req_doc_idcard_house);
            if(dataFormLdr.doc_idcard_type === "1") {
                setRdDocIsIdCardType("0");
            }else if(dataFormLdr.doc_idcard_house_type === "1"){
                setRdDocIsIdCardType("1");
            }else{
                setRdDocIsIdCardType("");
            }
            setCbDocIdcardType(dataFormLdr.doc_idcard_type);
            setFormIdCard(arrFormDocIdCard);
            setCbDocIdcardHouseType(dataFormLdr.doc_idcard_house_type);
            setFormIdCardHouse(arrFormDocIdCardHouse);
            setCheckBoxShareholders(dataFormLdr.req_doc_shareholders);
            setFormShareholders(arrFormDocShareholders);
            if(arrFormDocShareholders !== null){
                setSelectDocShareholderBu(arrFormDocShareholders.map(item => { return dataCompany.find(x => x.value === item.doc_shareholders_bu.toString()) ?? ""; }));
            }
            setCheckBoxTax(dataFormLdr.req_doc_tax);
            setCbDocTaxHeadOfficeType(dataFormLdr.doc_tax_head_ofiice_type);
            setCbDocTaxBranchType(dataFormLdr.doc_tax_branch_type);
            setFormTaxBranchs(arrFormDocTaxBranch);
            setCheckBoxOther(dataFormLdr.req_doc_other);
            setFormOther(arrFormDocOther);
            setRdCertifiedTrueCopy(dataFormLdr.certified_true_copy ?? "");
            setFileForUseDoc(dataFormLdr.for_use_doc ? setStringFileNameToArray(dataFormLdr.for_use_doc) : []);
            setFileMemoDoc(dataFormRequest.memo_doc ? setStringFileNameToArray(dataFormRequest.memo_doc) : []);
            LoadFormTempById(dataFormRequest.id_form_temp);
            if(dataFormRequest.request_no !== "draft" && dataFormLdr.approver_comment !== ""){
                setShowCommentApprover(true);
            }

            // 1. set group requestor can edit when id workflow = 4 or draft or user groupId2 when user can approve request.
            // 2,3. set group approver can edit when id workflow = 1,2
            if( (dataFormRequest.id_workflow_status === 4 && userEmail === dataFormRequest.create_request_by || dataFormRequest.id_workflow_status === 0) 
                || ((dataFormRequest.id_workflow_status === 4 && userEmail === dataFormRequest.request_by) || dataFormRequest.id_workflow_status === 0)
                || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
                || (dataFormRequest.id_workflow_status === 1 && userEmail === dataFormRequest.approve_request_by) 
                || (dataFormRequest.id_workflow_status === 2 && userEmail === dataFormRequest.approve_request_by)
            ){
                setFormIsDisabled(false);
            } else if( dataFormRequest.id_workflow_status > 4 ){
                setFormIsDisabled(false);
            } else {
                setFormIsDisabled(true);
            }
        }
    }, [dataFormLdr, dataFormRequest, dataCompany]);    

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_request: dataDetail.id_request || 0,
            id_request_type: dataDetail.id_request_type || 0,
            id_sub_request_type: dataDetail.id_sub_request_type || 0,
            id_sub_division_request_type: dataDetail.id_sub_division_request_type || 0,
            id_business_unit: dataDetail.id_business_unit || "",
            is_bu_other: "0",
            business_unit_other: dataDetail.business_unit_other || "",
            req_doc_cert: dataDetail?.req_doc_cert || "0",
            doc_certs: formDocCert || [{...modelFormDocCert}],
            req_doc_idcard_house: dataDetail?.req_doc_idcard_house || "0",
            doc_idcard_type: dataDetail?.doc_idcard_type || "0",
            doc_idcards: formIdCard || [{...modelFormDocIdCard}],
            doc_idcard_house_type: dataDetail?.doc_idcard_house_type || "0",
            doc_idcard_houses: formIdCardHouse || [{...modelFormDocIdCardHouse}],
            req_doc_passport: dataDetail?.req_doc_passport || "0",
            doc_passports: formPassport || [{...modelFormDocPassport}],
            req_doc_shareholders: dataDetail?.req_doc_shareholders || "0",
            doc_shareholders: formShareholders || [{...modelFormDocShareholders}],
            req_doc_tax: dataDetail?.req_doc_tax || "0",
            doc_tax_head_ofiice_type: dataDetail?.doc_tax_head_ofiice_type || "0",
            doc_tax_head_office_amount: dataDetail?.doc_tax_head_office_amount || "",
            doc_tax_branch_type: dataDetail?.doc_tax_branch_type || "0",
            doc_tax_branchs: formTaxBranchs || [{...modelFormDocTaxBranch}],
            req_doc_other: dataDetail?.req_doc_other || "0",
            doc_others: formOther || [{...modelFormDocOther}],
            for_use: dataDetail.for_use || "",
            for_use_doc: dataDetail.for_use_doc || "",
            certified_true_copy: dataDetail.certified_true_copy || "",
            reason_more_one_copy: dataDetail.reason_more_one_copy || "",
            memo_doc: dataFormRequest?.memo_doc || "",
            user_comment: dataDetail.user_comment || "",
            require_handled_by: dataFormRequest?.require_handled_by || dataDetail?.require_handled_by || "",
            approve_request_by: dataFormRequest?.approve_request_by || dataDetail?.approve_request_by || "",
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
            create_request_by: dataFormRequest?.create_request_by || dataDetail?.create_request_by || "",
            check_user_email: dataFormRequest?.create_request_by || dataDetail?.create_request_by || userEmail,
            check_request_no: dataFormRequest?.request_no || "",
            request_no: dataFormRequest?.request_no || "",
            id_workflow_status: dataFormRequest?.id_workflow_status || 0,
            is_more_one_copy: dataDetail.is_more_one_copy || "false",
        },
        validationSchema: Yup.object({
            id_business_unit: Yup.string().when("is_bu_other", {
                is: (is_bu_other) => is_bu_other === "0",
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            business_unit_other:  Yup.string().when("is_bu_other", {
                is: (is_bu_other) => is_bu_other === "1",
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            for_use: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            for_use_doc: Yup.string().required("กรุณาแนบไฟล์/Please attachment file"),
            certified_true_copy: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),            
            reason_more_one_copy: Yup.string().when("is_more_one_copy", {
                is: (is_more_one_copy) => is_more_one_copy === "true",
                then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            memo_doc: Yup.string().when("certified_true_copy", {
                is: (certified_true_copy) => certified_true_copy === "1",
                then: Yup.string().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            require_handled_by: Yup.string().email("กรุณาระบุอีเมลนักกฎหมาย/Please provide the lawyer's email address").matches(englishEmailRegex, "Email must be a valid English email address"),
            approve_request_by: Yup.string().when("check_request_no", {
                is: (check_request_no) => check_request_no === undefined || check_request_no === "draft",
                then: Yup.string().required("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address")
                .email("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address").matches(englishEmailRegex, "Email must be a valid English email address")
                .test('is-not-current-user', 'ไม่สามารถใช้อีเมลของผู้ใช้งานปัจจุบัน/You cannot use your own email', function(value) {
                    return value?.toLowerCase() !== userEmail; 
                }),
                otherwise: Yup.string().required("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address")
                .email("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address").matches(englishEmailRegex, "Email must be a valid English email address"),
            }),
            create_request_by: !checkShowInputUserCoordinator
            ? Yup.string().nullable()
            : Yup.string()
                .required("กรุณาระบุอีเมลผู้ประสานงาน/Please provide the coordinator's email address")
                .email("กรุณาระบุอีเมลผู้ประสานงาน/Please provide the coordinator's email address")
                .matches(englishEmailRegex, "Email must be a valid English email address"),
            doc_certs: Yup.array().of(
                Yup.object().shape({
                    doc_cert_bu: Yup.string().when(["req_doc_cert"], {
                        is: () => validation.values.req_doc_cert === "1",
                        then: Yup.string().when("is_bu_other", {
                            is: (is_bu_other) => is_bu_other === "0",
                            then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                            otherwise: Yup.string().notRequired(),
                        }),
                        otherwise: Yup.string().notRequired(),
                    }),
                    doc_cert_bu_other: Yup.string().when(["req_doc_cert"], {
                        is: () => validation.values.req_doc_cert === "1",
                        then: Yup.string().when("is_bu_other", {
                            is: (is_bu_other) => is_bu_other === "1",
                            then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                            otherwise: Yup.string().notRequired(),
                        }),
                        otherwise: Yup.string().notRequired(),
                    }),
                    doc_cert_amount: Yup.string().when(["req_doc_cert"], {
                        is: () => validation.values.req_doc_cert === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out").matches(/^[0-9,.]+$/, "กรุณากรอกเฉพาะตัวเลข\nPlease enter only numbers"),
                        otherwise: Yup.string().notRequired(),
                    })
                })
            ),
            doc_idcards: Yup.array().of(
                Yup.object().shape({
                    doc_idcard_name: Yup.string().when(["req_doc_idcard_house", "doc_idcard_type"], {
                        is: () => validation.values.req_doc_idcard_house === "1" && validation.values.doc_idcard_type === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    doc_idcard_amount: Yup.string().when(["req_doc_idcard_house", "doc_idcard_type"], {
                        is: () => validation.values.req_doc_idcard_house === "1" && validation.values.doc_idcard_type === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล\nPlease fill out").matches(/^[0-9,.]+$/, "กรุณากรอกเฉพาะตัวเลข\nPlease enter only numbers"),
                        otherwise: Yup.string().notRequired(),
                    })
                })
            ),
            doc_idcard_houses: Yup.array().of(
                Yup.object().shape({
                    doc_idcard_house_name: Yup.string().when(["req_doc_idcard_house", "doc_idcard_type"], {
                        is: () => validation.values.req_doc_idcard_house === "1" && validation.values.doc_idcard_house_type === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    doc_idcard_house_amount: Yup.string().when(["req_doc_idcard_house", "doc_idcard_type"], {
                        is: () => validation.values.req_doc_idcard_house === "1" && validation.values.doc_idcard_house_type === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล\nPlease fill out").matches(/^[0-9,.]+$/, "กรุณากรอกเฉพาะตัวเลข\nPlease enter only numbers"),
                        otherwise: Yup.string().notRequired(),
                    })
                })
            ),
            doc_passports: Yup.array().of(
                Yup.object().shape({
                    doc_passport_name: Yup.string().when(["req_doc_passport"], {
                        is: () => validation.values.req_doc_passport === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    doc_passport_amount: Yup.string().when(["req_doc_passport"], {
                        is: () => validation.values.req_doc_passport === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล\nPlease fill out").matches(/^[0-9,.]+$/, "กรุณากรอกเฉพาะตัวเลข\nPlease enter only numbers"),
                        otherwise: Yup.string().notRequired(),
                    })
                })
            ),
            doc_shareholders: Yup.array().of(
                Yup.object().shape({
                    doc_shareholders_bu: Yup.string().when(["req_doc_shareholders"], {
                        is: () => validation.values.req_doc_shareholders === "1",
                        then: Yup.string().when("is_bu_other", {
                            is: (is_bu_other) => is_bu_other === "0",
                            then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                            otherwise: Yup.string().notRequired(),
                        }),
                        otherwise: Yup.string().notRequired(),
                    }),
                    doc_shareholders_bu_other: Yup.string().when(["req_doc_shareholders"], {
                        is: () => validation.values.req_doc_shareholders === "1",
                        then: Yup.string().when("is_bu_other", {
                            is: (is_bu_other) => is_bu_other === "1",
                            then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                            otherwise: Yup.string().notRequired(),
                        }),
                        otherwise: Yup.string().notRequired(),
                    }),
                    doc_shareholders_amount: Yup.string().when(["req_doc_shareholders"], {
                        is: () => validation.values.req_doc_shareholders === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out").matches(/^[0-9,.]+$/, "กรุณากรอกเฉพาะตัวเลข\nPlease enter only numbers"),
                        otherwise: Yup.string().notRequired(),
                    })
                })
            ),
            doc_tax_head_office_amount: Yup.string().when(["req_doc_tax", "doc_tax_head_ofiice_type"], {
                is: () => validation.values.req_doc_tax === "1" && validation.values.doc_tax_head_ofiice_type === "1",
                then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out").matches(/^[0-9,.]+$/, "กรุณากรอกเฉพาะตัวเลข/Please enter only numbers"),
                otherwise: Yup.string().notRequired(),
            }),
            doc_tax_branchs: Yup.array().of(
                Yup.object().shape({
                    doc_tax_branch_name: Yup.string().when(["req_doc_tax", "doc_tax_branch_type"], {
                        is: () => validation.values.req_doc_tax === "1" && validation.values.doc_tax_branch_type === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    doc_tax_branch_amount: Yup.string().when(["req_doc_tax", "doc_tax_branch_type"], {
                        is: () => validation.values.req_doc_tax === "1" && validation.values.doc_tax_branch_type === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล\nPlease fill out").matches(/^[0-9,.]+$/, "กรุณากรอกเฉพาะตัวเลข\nPlease enter only numbers"),
                        otherwise: Yup.string().notRequired(),
                    })
                })
            ),
            doc_others: Yup.array().of(
                Yup.object().shape({
                    doc_other_name: Yup.string().when(["req_doc_other"], {
                        is: () => validation.values.req_doc_other === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    doc_other_amount: Yup.string().when(["req_doc_other"], {
                        is: () => validation.values.req_doc_other === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล\nPlease fill out").matches(/^[0-9,.]+$/, "กรุณากรอกเฉพาะตัวเลข\nPlease enter only numbers"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    doc_other_reason: Yup.string().when(["req_doc_other"], {
                        is: () => validation.values.req_doc_other === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    })
                })
            )
        }),
        onSubmit: (values) => {
            values.id_business_unit = (values.id_business_unit !== "") ? parseInt(values.id_business_unit) : 0;
            values.file_for_use_doc = fileForUseDoc;
            values.file_memo_doc = fileMemoDoc;
            values.approve_request_by = values.approve_request_by?.toLowerCase();
            values.require_handled_by = values.require_handled_by?.toLowerCase();
            values.create_request_by = values.create_request_by?.toLowerCase();
            values.doc_tax_head_office_amount = (values.doc_tax_head_office_amount > 0) ? parseInt(values.doc_tax_head_office_amount) : 0;
            values.legal_authorized = emailLegalAuthorized;
            values.legal_admin = emailLegalAdmin;
            const arrDocCerts = getFillArray(values.doc_certs, 5, modelFormDocCert);
            const valueDocCert = arrDocCerts.reduce((acc, item, index) => {
                acc[`doc_cert_bu_${index + 1}`] = (item.doc_cert_bu !== "") ? parseInt(item.doc_cert_bu) : 0;
                // acc[`is_bu_other_${index + 1}`] = item.is_bu_other ?? "";
                acc[`doc_cert_bu_other_${index + 1}`] = item.doc_cert_bu_other ?? "";
                acc[`doc_cert_bu_expire_${index + 1}`] = item.doc_cert_bu_expire ?? "";
                acc[`doc_cert_amount_${index + 1}`] = (item.doc_cert_amount > 0) ? parseInt(item.doc_cert_amount) : 0;
                return acc;
            }, {});

            const arrDocIdCard = getFillArray(values.doc_idcards, 5, modelFormDocIdCard);
            const valueDocIdCard = arrDocIdCard.reduce((acc, item, index) => {
                acc[`doc_idcard_name_${index + 1}`] = item.doc_idcard_name ?? "";
                acc[`doc_idcard_amount_${index + 1}`] = (item.doc_idcard_amount > 0) ? parseInt(item.doc_idcard_amount) : 0;
                return acc;
            }, {});

            const arrDocIdCardHouse = getFillArray(values.doc_idcard_houses, 5, modelFormDocIdCardHouse);
            const valueDocIdCardHouse = arrDocIdCardHouse.reduce((acc, item, index) => {
                acc[`doc_idcard_house_name_${index + 1}`] = item.doc_idcard_house_name ?? "";
                acc[`doc_idcard_house_amount_${index + 1}`] = (item.doc_idcard_house_amount > 0) ? parseInt(item.doc_idcard_house_amount) : 0;
                return acc;
            }, {});

            const arrDocPassport = getFillArray(values.doc_passports, 5, modelFormDocPassport);
            const valueDocPassport = arrDocPassport.reduce((acc, item, index) => {
                acc[`doc_passport_name_${index + 1}`] = item.doc_passport_name ?? "";
                acc[`doc_passport_amount_${index + 1}`] = (item.doc_passport_amount > 0) ? parseInt(item.doc_passport_amount) : 0;
                return acc;
            }, {});
            
            const arrDocShareholder = getFillArray(values.doc_shareholders, 5, modelFormDocShareholders);
            const valueDocShareholder = arrDocShareholder.reduce((acc, item, index) => {
                acc[`doc_shareholders_bu_${index + 1}`] = (item.doc_shareholders_bu !== "") ? parseInt(item.doc_shareholders_bu) : 0;
                // acc[`is_bu_other_${index + 1}`] = item.is_bu_other ?? "";
                acc[`doc_shareholders_bu_other_${index + 1}`] = item.doc_shareholders_bu_other ?? "";
                acc[`doc_shareholders_expire_${index + 1}`] = item.doc_shareholders_expire ?? "";
                acc[`doc_shareholders_amount_${index + 1}`] = (item.doc_shareholders_amount > 0) ? parseInt(item.doc_shareholders_amount) : 0;
                return acc;
            }, {});

            const arrDocTaxBranch = getFillArray(values.doc_tax_branchs, 5, modelFormDocTaxBranch);
            const valueDocTaxBranch = arrDocTaxBranch.reduce((acc, item, index) => {
                acc[`doc_tax_branch_name_${index + 1}`] = item.doc_tax_branch_name ?? "";
                acc[`doc_tax_branch_amount_${index + 1}`] = (item.doc_tax_branch_amount > 0) ? parseInt(item.doc_tax_branch_amount) : 0;
                return acc;
            }, {});
            
            const arrDocOther = getFillArray(values.doc_others, 10, modelFormDocOther);
            const valueDocOther = arrDocOther.reduce((acc, item, index) => {
                acc[`doc_other_name_${index + 1}`] = item.doc_other_name ?? "";
                acc[`doc_other_expire_${index + 1}`] = item.doc_other_expire ?? "";
                acc[`doc_other_amount_${index + 1}`] = (item.doc_other_amount > 0) ? parseInt(item.doc_other_amount) : 0;
                acc[`doc_other_reason_${index + 1}`] = item.doc_other_reason ?? "";
                return acc;
            }, {});

            const data = Object.assign({}, values, valueDocCert, valueDocIdCard, valueDocIdCardHouse, valueDocPassport, valueDocShareholder, valueDocTaxBranch, valueDocOther);
            onSave(data);
        }
    });

    const validationDraft = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_request: dataDetail.id_request || 0,
            id_request_type: dataDetail.id_request_type || 0,
            id_sub_request_type: dataDetail.id_sub_request_type || 0,
            id_sub_division_request_type: dataDetail.id_sub_division_request_type || 0,
            id_business_unit: dataDetail.id_business_unit || "",
            is_bu_other: "0",
            business_unit_other: dataDetail.business_unit_other || "",
            req_doc_cert: dataDetail?.req_doc_cert || "0",
            doc_certs: formDocCert || [{...modelFormDocCert}],
            req_doc_idcard_house: dataDetail?.req_doc_idcard_house || "0",
            doc_idcard_type: dataDetail?.doc_idcard_type || "0",
            doc_idcards: formIdCard || [{...modelFormDocIdCard}],
            doc_idcard_house_type: dataDetail?.doc_idcard_house_type || "0",
            doc_idcard_houses: formIdCardHouse || [{...modelFormDocIdCardHouse}],
            req_doc_passport: dataDetail?.req_doc_passport || "0",
            doc_passports: formPassport || [{...modelFormDocPassport}],
            req_doc_shareholders: dataDetail?.req_doc_shareholders || "0",
            doc_shareholders: formShareholders || [{...modelFormDocShareholders}],
            req_doc_tax: dataDetail?.req_doc_tax || "0",
            doc_tax_head_ofiice_type: dataDetail?.doc_tax_head_ofiice_type || "0",
            doc_tax_head_office_amount: dataDetail?.doc_tax_head_office_amount || "",
            doc_tax_branch_type: dataDetail?.doc_tax_branch_type || "0",
            doc_tax_branchs: formTaxBranchs || [{...modelFormDocTaxBranch}],
            req_doc_other: dataDetail?.req_doc_other || "0",
            doc_others: formOther || [{...modelFormDocOther}],
            for_use: dataDetail.for_use || "",
            for_use_doc: dataDetail.for_use_doc || "",
            certified_true_copy: dataDetail.certified_true_copy || "",
            reason_more_one_copy: dataDetail.reason_more_one_copy || "",
            memo_doc: dataDetail.memo_doc || "",
            user_comment: dataDetail.user_comment || "",
            require_handled_by: dataFormRequest?.require_handled_by || dataDetail?.require_handled_by || "",
            approve_request_by: dataFormRequest?.approve_request_by || dataDetail?.approve_request_by || "",
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
            create_request_by: dataFormRequest?.create_request_by || dataDetail?.create_request_by || "",
            check_user_email: dataFormRequest?.create_request_by || dataDetail?.create_request_by || userEmail,
            check_request_no: dataFormRequest?.request_no || "",
            request_no: dataFormRequest?.request_no || "",
            id_workflow_status: dataFormRequest?.id_workflow_status || 0,
        },
        onSubmit: (values) => { 
            values.id_business_unit = (values.id_business_unit !== "") ? parseInt(values.id_business_unit) : 0;    
            values.file_for_use_doc = fileForUseDoc;
            values.file_memo_doc = fileMemoDoc;
            values.approve_request_by = values.approve_request_by?.toLowerCase();
            values.require_handled_by = values.require_handled_by?.toLowerCase();
            values.create_request_by = values.create_request_by?.toLowerCase();
            values.doc_tax_head_office_amount = (values.doc_tax_head_office_amount > 0) ? parseInt(values.doc_tax_head_office_amount) : 0;
            values.legal_authorized = emailLegalAuthorized;
            values.legal_admin = emailLegalAdmin;
            const arrDocCerts = getFillArray(values.doc_certs, 5, modelFormDocCert);
            const valueDocCert = arrDocCerts.reduce((acc, item, index) => {
                acc[`doc_cert_bu_${index + 1}`] = (item.doc_cert_bu !== "") ? parseInt(item.doc_cert_bu) : 0;
                // acc[`is_bu_other_${index + 1}`] = item.is_bu_other ?? "";
                acc[`doc_cert_bu_other_${index + 1}`] = item.doc_cert_bu_other ?? "";
                acc[`doc_cert_bu_expire_${index + 1}`] = item.doc_cert_bu_expire ?? "";
                acc[`doc_cert_amount_${index + 1}`] = (item.doc_cert_amount > 0) ? parseInt(item.doc_cert_amount) : 0;
                return acc;
            }, {});
            
            const arrDocIdCard = getFillArray(values.doc_idcards, 5, modelFormDocIdCard);
            const valueDocIdCard = arrDocIdCard.reduce((acc, item, index) => {
                acc[`doc_idcard_name_${index + 1}`] = item.doc_idcard_name ?? "";
                acc[`doc_idcard_amount_${index + 1}`] = (item.doc_idcard_amount > 0) ? parseInt(item.doc_idcard_amount) : 0;
                return acc;
            }, {});

            const arrDocIdCardHouse = getFillArray(values.doc_idcard_houses, 5, modelFormDocIdCardHouse);
            const valueDocIdCardHouse = arrDocIdCardHouse.reduce((acc, item, index) => {
                acc[`doc_idcard_house_name_${index + 1}`] = item.doc_idcard_house_name ?? "";
                acc[`doc_idcard_house_amount_${index + 1}`] = (item.doc_idcard_house_amount > 0) ? parseInt(item.doc_idcard_house_amount) : 0;
                return acc;
            }, {});

            const arrDocPassport = getFillArray(values.doc_passports, 5, modelFormDocPassport);
            const valueDocPassport = arrDocPassport.reduce((acc, item, index) => {
                acc[`doc_passport_name_${index + 1}`] = item.doc_passport_name ?? "";
                acc[`doc_passport_amount_${index + 1}`] = (item.doc_passport_amount > 0) ? parseInt(item.doc_passport_amount) : 0;
                return acc;
            }, {});
            
            const arrDocShareholder = getFillArray(values.doc_shareholders, 5, modelFormDocShareholders);
            const valueDocShareholder = arrDocShareholder.reduce((acc, item, index) => {
                acc[`doc_shareholders_bu_${index + 1}`] = (item.doc_shareholders_bu !== "") ? parseInt(item.doc_shareholders_bu) : 0;
                // acc[`is_bu_other_${index + 1}`] = item.is_bu_other ?? "";
                acc[`doc_shareholders_bu_other_${index + 1}`] = item.doc_shareholders_bu_other ?? "";
                acc[`doc_shareholders_expire_${index + 1}`] = item.doc_shareholders_expire ?? "";
                acc[`doc_shareholders_amount_${index + 1}`] = (item.doc_shareholders_amount > 0) ? parseInt(item.doc_shareholders_amount) : 0;
                return acc;
            }, {});

            const arrDocTaxBranch = getFillArray(values.doc_tax_branchs, 5, modelFormDocTaxBranch);
            const valueDocTaxBranch = arrDocTaxBranch.reduce((acc, item, index) => {
                acc[`doc_tax_branch_name_${index + 1}`] = item.doc_tax_branch_name ?? "";
                acc[`doc_tax_branch_amount_${index + 1}`] = (item.doc_tax_branch_amount > 0) ? parseInt(item.doc_tax_branch_amount) : 0;
                return acc;
            }, {});
            
            const arrDocOther = getFillArray(values.doc_others, 10, modelFormDocOther);
            const valueDocOther = arrDocOther.reduce((acc, item, index) => {
                acc[`doc_other_name_${index + 1}`] = item.doc_other_name ?? "";
                acc[`doc_other_expire_${index + 1}`] = item.doc_other_expire ?? "";
                acc[`doc_other_amount_${index + 1}`] = (item.doc_other_amount > 0) ? parseInt(item.doc_other_amount) : 0;
                acc[`doc_other_reason_${index + 1}`] = item.doc_other_reason ?? "";
                return acc;
            }, {});

            const data = Object.assign({}, values, valueDocCert, valueDocIdCard, valueDocIdCardHouse, valueDocPassport, valueDocShareholder, valueDocTaxBranch, valueDocOther);
            onSaveDraft(data);
        }
    });

    useEffect(() => {
        if(CheckShowReasonMoreOneCopy(0) === "true"){
            setShowReasonMoreOneCopy(true);                    
        }else{
            setShowReasonMoreOneCopy(false);
        }
    }, [validation.values.doc_certs, validation.values.doc_idcards, validation.values.doc_idcard_houses, validation.values.doc_passports, validation.values.doc_shareholders, validation.values.doc_tax_head_office_amount, validation.values.doc_tax_branchs, validation.values.doc_others]);

    useEffect(() => {
        if(showReasonMoreOneCopy === true){
            validation.handleChange("is_more_one_copy")("true");    
        }else{
            validation.handleChange("is_more_one_copy")("false");
            validation.handleChange("reason_more_one_copy")("");
            validationDraft.handleChange("reason_more_one_copy")("");
        }
    }, [showReasonMoreOneCopy]);

    const validationReturn = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_request: dataDetail.id_request || 0,
            id_request_type: dataDetail.id_request_type || 0,
            id_sub_request_type: dataDetail.id_sub_request_type || 0,
            id_sub_division_request_type: dataDetail.id_sub_division_request_type || 0,
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
        },
        validationSchema: Yup.object({
            approver_comment: Yup.string().trim().required("กรุณาระบุความเห็นเพิ่มเติม"),
        }),
        onSubmit: (values) => {
            // console.log(values);
        }
    });

    const GetUrlBack = () => {
        const urlBack = (dataFormRequest.table_name !== "" && dataFormRequest.table_name !== null && dataFormRequest.table_name !== undefined) ? "/request-form/" + btoa(dataFormRequest.table_name) : "/all-type-request";
        return urlBack;
    };
    
    const OnSetFileForUseDoc = (files) => {
        const names = files.map(file => file.name).join(",");
        validation.handleChange("for_use_doc")(names);
        validationDraft.handleChange("for_use_doc")(names);
        setFileForUseDoc(files);
        setIsSaveEnabled(true);
    };

    const OnSetFileMemoDoc = (file) => {
        const fileName = (file.length > 0) ? file[0].name : "";
        setFileMemoDoc(file);
        validation.handleChange('memo_doc')(fileName);
        setIsSaveEnabled(true);
    };

    const OnClickAddDocCert = () => {
        const newItem = {...modelFormDocCert};
        if (validation.values.doc_certs.length < 5) {
            validation.setFieldValue("doc_certs", [...validation.values.doc_certs, newItem]);
            validationDraft.setFieldValue("doc_certs", [...validationDraft.values.doc_certs, newItem]);
        }
    };

    const OnClickRemoveDocCert = (index) => {
        const newItemSelect = selectDocCertBu.filter((_, i) => i !== index);
        setSelectDocCertBu(newItemSelect);

        const newItems = validation.values.doc_certs.filter((_, i) => i !== index);
        validation.setFieldValue("doc_certs", newItems);
        validationDraft.setFieldValue("doc_certs", newItems);
    };

    const OnClickAddDocIdCard = () => {
        const newItem = {...modelFormDocIdCard};
        if (validation.values.doc_idcards.length < 5) {
            validation.setFieldValue("doc_idcards", [...validation.values.doc_idcards, newItem]);
            validationDraft.setFieldValue("doc_idcards", [...validationDraft.values.doc_idcards, newItem]);
        }
    };

    const OnClickRemoveDocIdCard = (index) => {
        const newItems = validation.values.doc_idcards.filter((_, i) => i !== index);
        validation.setFieldValue("doc_idcards", newItems);
        validationDraft.setFieldValue("doc_idcards", newItems);
   };

    const OnClickAddDocIdCardHouse = () => {
        const newItem = {...modelFormDocIdCardHouse};
        if (validation.values.doc_idcard_houses.length < 5) {
            validation.setFieldValue("doc_idcard_houses", [...validation.values.doc_idcard_houses, newItem]);
            validationDraft.setFieldValue("doc_idcard_houses", [...validationDraft.values.doc_idcard_houses, newItem]);
        }
    };

    const OnClickRemoveDocIdCardHouse = (index) => {
        const newItems = validation.values.doc_idcard_houses.filter((_, i) => i !== index);
        validation.setFieldValue("doc_idcard_houses", newItems);
        validationDraft.setFieldValue("doc_idcard_houses", newItems);
    };

    const OnClickAddDocPassport = () => {
        const newItem = {...modelFormDocPassport};
        if (validation.values.doc_passports.length < 5) {
            validation.setFieldValue("doc_passports", [...validation.values.doc_passports, newItem]);
            validationDraft.setFieldValue("doc_passports", [...validationDraft.values.doc_passports, newItem]);
        }
    };

    const OnClickRemovePassport = (index) => {
        const newItems = validation.values.doc_passports.filter((_, i) => i !== index);
        validation.setFieldValue("doc_passports", newItems);
        validationDraft.setFieldValue("doc_passports", newItems);
   };

    const OnClickAddShareholders = () => {
        const newItem = {...modelFormDocShareholders};
        if (validation.values.doc_shareholders.length < 5) {
            validation.setFieldValue("doc_shareholders", [...validation.values.doc_shareholders, newItem]);
            validationDraft.setFieldValue("doc_shareholders", [...validationDraft.values.doc_shareholders, newItem]);
        }
    };

    const OnClickRemoveShareholders = (index) => {
        const newItemSelect = selectDocShareholderBu.filter((_, i) => i !== index);
        setSelectDocShareholderBu(newItemSelect);

        const newItems = validation.values.doc_shareholders.filter((_, i) => i !== index);
        validation.setFieldValue("doc_shareholders", newItems);
        validationDraft.setFieldValue("doc_shareholders", newItems);
    };

    const OnClickAddDocTaxBranch = () => {
        const newItem = {...modelFormDocTaxBranch};
        if (validation.values.doc_tax_branchs.length < 5) {
            validation.setFieldValue("doc_tax_branchs", [...validation.values.doc_tax_branchs, newItem]);
            validationDraft.setFieldValue("doc_tax_branchs", [...validationDraft.values.doc_tax_branchs, newItem]);
        }
    };

    const OnClickRemoveDocTaxBranch = (index) => {
        const newItems = validation.values.doc_tax_branchs.filter((_, i) => i !== index);
        validation.setFieldValue("doc_tax_branchs", newItems);
        validationDraft.setFieldValue("doc_tax_branchs", newItems);
    };

    const OnCLickAddOther = () => {
        const newItem = {...modelFormDocOther};
        if (validation.values.doc_others.length < 10) {
            validation.setFieldValue("doc_others", [...validation.values.doc_others, newItem]);
            validationDraft.setFieldValue("doc_others", [...validationDraft.values.doc_others, newItem]);
        }
    };

    const OnClickRemoveOther = (index) => {
        const newItems = validation.values.doc_others.filter((_, i) => i !== index);
        validation.setFieldValue("doc_others", newItems);
        validationDraft.setFieldValue("doc_others", newItems);
    };

    const onClickCheckSaveDraft = () => {
        dataUser.email === dataFormRequest.approve_request_by ? setIsSaveEnabled(false) : setIsSaveEnabled(true);
        if(( dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by ) 
            || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
            || dataFormRequest.id_workflow_status === 4 
            || dataFormRequest.id_workflow_status === 0){
            validationDraft.submitForm();
        } else if(dataFormLdr.id_request === "" || dataFormLdr.id_request === 0){
            validationDraft.submitForm();
        } else {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "You Are not authorized to action this.",
                showConfirmButton: false,
                showCloseButton: true,
            });
        }
    };

    const onClickCheckSubmit = async () => {
        const errors = await validation.validateForm();
    
        // ตรวจสอบว่ามี error หรือไม่
        if (Object.keys(errors).length > 0) {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                showConfirmButton: false,
                showCloseButton: true,
            });
            // return; // หยุดการทำงานถ้ามี error
        }
    
        // ถ้าไม่มี error ให้ทำการ submit form
        if (!dataFormRequest.id_workflow_status) {
            validation.submitForm();
        } else if ( checkAuthorizedSubmitOrApprove ) {
            validation.submitForm();
        } else {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "You Are not authorized to action this.",
                showConfirmButton: false,
                showCloseButton: true,
            });
        }
    };

    const onClickCheckReturn = async () => {
        setShowCommentApprover(true);
        
        // ทำการ submit form เพื่อ trigger การ validate
        await validationReturn.submitForm();
        // ตรวจสอบค่าของ showCommentApprover
        if (showCommentApprover) {
            // ตรวจสอบว่ามีข้อผิดพลาดหรือไม่
            const errors = validationReturn.errors;
            // console.log(errors);
            
            if (Object.keys(errors).length === 0) {
                // ตรวจสอบสิทธิ์การอนุมัติ
                if (checkAuthorizedReturn) {
                    onReturn(dataFormRequest, validation.values);
                } else {
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "You Are not authorized to action this.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            } else {
                // ถ้ามีข้อผิดพลาด แสดงข้อความเตือน
                Swal.fire({
                    iconHtml: IconAlertError,
                    title: "กรุณากรอกข้อมูลความเห็นของผู้อนุมัติ",
                    showConfirmButton: false,
                    showCloseButton: true,
                });
            }
        }
    };

    const ClearDataDocCert = (value) => {
        if(value === "0"){
            setSelectDocCertBu([null]);            
            validation.setFieldValue("doc_certs", [{...modelFormDocCert}]);
            validationDraft.setFieldValue("doc_certs", [{...modelFormDocCert}]);
        }
    };

    const ClearDataIdCard = (value) => {
        if(value === "0"){
            setRdDocIsIdCardType("");
            setCbDocIdcardType("0");
            setCbDocIdcardHouseType("0");
            validation.setFieldValue("doc_idcard_type", "0");
            validationDraft.setFieldValue("doc_idcard_type", "0");
            validation.setFieldValue("doc_idcard_house_type", "0");
            validationDraft.setFieldValue("doc_idcard_house_type", "0");
            validation.setFieldValue("doc_idcards", [{...modelFormDocIdCard}]);
            validationDraft.setFieldValue("doc_idcards", [{...modelFormDocIdCard}]);
            validation.setFieldValue("doc_idcard_houses", [{...modelFormDocIdCardHouse}]);
            validationDraft.setFieldValue("doc_idcard_houses", [{...modelFormDocIdCardHouse}]);
        }
    };

    const ClearDataSubIdCardType = (value) => {
        if(value === "0"){
            validation.setFieldValue("doc_idcards", [{...modelFormDocIdCard}]);
            validationDraft.setFieldValue("doc_idcards", [{...modelFormDocIdCard}]);
        }
    };

    const ClearDataSubIdCardHouseType = (value) => {
        if(value === "0"){
            validation.setFieldValue("doc_idcard_houses", [{...modelFormDocIdCardHouse}]);
            validationDraft.setFieldValue("doc_idcard_houses", [{...modelFormDocIdCardHouse}]);
        }
    };

    const ClearDataPassport = (value) => {
        if(value === "0"){
            validation.setFieldValue("doc_passports", [{...modelFormDocPassport}]);
            validationDraft.setFieldValue("doc_passports", [{...modelFormDocPassport}]);
        }
    };

    const ClearDataShareholder = (value) => {
        if(value === "0"){
            setSelectDocShareholderBu([null]);
            validation.setFieldValue("doc_shareholders", [{...modelFormDocShareholders}]);
            validationDraft.setFieldValue("doc_shareholders", [{...modelFormDocShareholders}]);            
        }
    };

    const ClearDataTax = (value) => {
        if(value === "0"){
            setCbDocTaxHeadOfficeType("0");
            setCbDocTaxBranchType("0");
            validation.setFieldValue("doc_tax_head_ofiice_type", "0");
            validationDraft.setFieldValue("doc_tax_head_ofiice_type", "0");
            validation.setFieldValue("doc_tax_branch_type", "0");
            validationDraft.setFieldValue("doc_tax_branch_type", "0");
            validation.setFieldValue("doc_tax_head_office_amount", "");
            validationDraft.setFieldValue("doc_tax_head_office_amount", "");
            validation.setFieldValue("doc_tax_branchs", [{...modelFormDocTaxBranch}]);
            validationDraft.setFieldValue("doc_tax_branchs", [{...modelFormDocTaxBranch}]);
        }
    };

    const ClearDataTaxHeadOfficeType = (value) => {
        if(value === "0"){
            validation.setFieldValue("doc_tax_head_office_amount", "");
            validationDraft.setFieldValue("doc_tax_head_office_amount", "");
        }
    };

    const ClearDataTaxBranchType = (value) => {
        if(value === "0"){
            validation.setFieldValue("doc_tax_branchs", [{...modelFormDocTaxBranch}]);
            validationDraft.setFieldValue("doc_tax_branchs", [{...modelFormDocTaxBranch}]);
        }
    };

    const ClearDataDocOther = (value) => {
        if(value === "0"){
            validation.setFieldValue("doc_others", [{...modelFormDocOther}]);
            validationDraft.setFieldValue("doc_others", [{...modelFormDocOther}]);
        }
    };

    const CheckShowReasonMoreOneCopy = (itemAmount) => {
        if(itemAmount <= 1){
            let arrFindDocCerts = validation.values.doc_certs.find((item) => item.doc_cert_amount > 1);                    
            if(arrFindDocCerts !== undefined){
                return "true";
            }
            let arrFindDocIdCards = validation.values.doc_idcards.find((item) => item.doc_idcard_amount > 1);            
            if(arrFindDocIdCards !== undefined){
                return "true";
            }
            let arrFindDocIdCardHouses = validation.values.doc_idcard_houses.find((item) => item.doc_idcard_house_amount > 1);        
            if(arrFindDocIdCardHouses !== undefined){
                return "true";
            }
            let arrFindDocPassports = validation.values.doc_passports.find((item) => item.doc_passport_amount > 1);            
            if(arrFindDocPassports !== undefined){
                return "true";
            }
            let arrFindDocShareholders = validation.values.doc_shareholders.find((item) => item.doc_shareholders_amount > 1);
            if(arrFindDocShareholders !== undefined){
                return "true";
            }
            let dataDocTaxHeadOffice = validation.values.doc_tax_head_office_amount;
            if(dataDocTaxHeadOffice > 1){
                return "true";
            }

            let arrFindDocTaxBranchs = validation.values.doc_tax_branchs.find((item) => item.doc_tax_branch_amount > 1);
            if(arrFindDocTaxBranchs !== undefined){
                return "true";
            }
            let arrFindDocOthers = validation.values.doc_others.find((item) => item.doc_other_amount > 1);
            if(arrFindDocOthers !== undefined){
                return "true";
            }
            return "false";
        }
        return "true";
    };

    const LoadProfileUser = (email) => {
        let url = ConfigData.API_URL + "user/search?status=1&email=" + email;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setDataUser(respData.data[0]);
                LoadLegalAuthorized(respData.data[0].id_business_unit);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadFormTempById = (idFormTemp) =>{
        let url = ConfigData.API_URL + "form-temp/" + idFormTemp;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setFormTemp(respData.data[0]);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataBusinessUnit = () => {
        let url = ConfigData.API_URL + "business-unit/search?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_en,
                        value: e.id.toString()
                    };
                });
                setDataCompany(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadLegalAdmin = (groupId) => {
        let url = ConfigData.API_URL + "user/?status=1&id_user_group=" + groupId;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
            responseType: "json",
        })
        .then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                setEmailLegalAdmin(respData.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const LoadLegalAuthorized = (idBusinessUnit) => {
        let url = ConfigData.API_URL + "map-user-assign/search?status=1&id_business_unit=" + idBusinessUnit;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                if(respData.data.length > 0){
                    setEmailLegalAuthorized(respData.data);
                } else {
                    // sayam@btsgroup.co.th, anchalee@btsgroup.co.th
                    setEmailLegalAuthorized([{"email": "sayam@btsgroup.co.th"},{"email": "anchalee@btsgroup.co.th"}]);
                }
            } else {
                setEmailLegalAuthorized("");
            }
        })
        .catch(error => {
            console.log(error);
        });
    };

    const onReturn = (dataRequest, dataFormLdr) => {
        Swal.fire({
            icon: 'info',
            title: 'Loading...',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });
  
        let isSaveSucess = true;
        (async () => {
            try{
                let dataReturn = await UpdateReturn(dataRequest.id);
                isSaveSucess = (dataReturn.is_sucess === true && isSaveSucess === true) ? true : false;
                
                const dataRequestWorkFlows = {
                    "id_request": dataRequest.id,
                    "id_workflow_status" : 4,
                    "do_by" : userEmail,
                    "send_to" : dataRequest.request_by,
                    "cc_to" : null,
                    "comment" : dataFormLdr.approver_comment,
                    "document" : null,
                    "consent" : null,
                    "do_date" : newDateTime,
                };
                let dataRequestWorkFlow = await AddRequestWorkFlow(dataRequestWorkFlows);
                isSaveSucess = (dataRequestWorkFlow.is_sucess === true && isSaveSucess === true) ? true : false;

                if(isSaveSucess === true){
                    let isSendMail = await SendMailReturn(dataRequestWorkFlow.data[0]);
                    if( isSendMail === true ){
                        Swal.close(); // Close loading spinner
                        Swal.fire({
                                iconHtml: IconAlertReturn,
                                title: "Return to user who request.",
                                showConfirmButton: false,
                                showCloseButton: true,
                                // showConfirmButton: false,
                            }).then(() => {
                                // props.nextStep();
                                history.push(GetUrlBack());
                            });
                    }else{
                        Swal.close(); // Close loading spinner
                        Swal.fire({
                            iconHtml: IconAlertError,
                            title: "Failed to send email to user who request.",
                            showConfirmButton: false,
                            showCloseButton: true,
                        });
                    }
                }else{
                    Swal.close(); // Close loading spinner
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "Failed to save data.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            } catch(error){
                console.log(error);
            }
        })();
    };

    const UpdateReturn = async (id) => {
        let url = ConfigData.API_URL + "request/approval-return/" + id;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url,{}, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // setDataIdRequest(respData.data)
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const AddRequestWorkFlow = async (dataRequestWorkFlows) => {
        let url = ConfigData.API_URL + "request-workflow/";
        let data = dataRequestWorkFlows;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.post(url, data, { headers: { 
                                'Authorization' : token,
                                'User': userId,
                            }, responseType: "json" }
                        );
            let respData = resp.data;
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const SendMailReturn = async (data) => {
        const url = ConfigData.API_URL + "email/send";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let arrTo = data.send_to.split(",");
        let dataReq = {
            "to": arrTo,
            "template_id": 2,
            "request_id": data.id_request,
        };
        try {
            const resp = await axios.post(url, dataReq, { headers: { 
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        } catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    return (
        <React.Fragment>
            <div id="form-request" className="mx-auto">
                <Form className="needs-validation"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        validationDraft.handleSubmit();
                        validationReturn.handleSubmit();
                        return false;
                    }}
                >
                    <div id="section-page-1-2">
                        <Row>
                            <Col md={12}>
                                <span className="span-title">
                                    ข้อมูลทั่วไป (Request General Information)
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup className="pt-3">
                                    <Label className="label-title">ประเภทคำขอ (Type of Request)</Label>
                                    <Input
                                        type="text"
                                        name="typeOfRequest"
                                        value={dataFormRequest.name_en_request_type ? dataFormRequest.name_en_request_type || "" : formTemp.name_en_request_type || ""}
                                        disabled
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup className="pt-3">
                                    <Label className="label-title">งานของบริษัท (Company’s Work)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prIdBusinessUnit"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prIdBusinessUnit" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดระบุบริษัทที่เป็นเจ้าของเรื่อง<br/>Please specify the company who is the owner of this request.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Select id="ddlIdBusinessUnit"
                                        name="id_business_unit"
                                        className="txt-placeholder"
                                        options={dataCompany}
                                        placeholder={(validation.values.is_bu_other === "0") ? "กรอกชื่อว่าเป็นงานของบริษัทใด" : ""}
                                        isClearable={true}
                                        isSearchable={true}
                                        value={selectIdBusinessUnit}
                                        onChange={(selected) => {
                                            setSelectIdBusinessUnit(selected);
                                            validation.setFieldValue("id_business_unit", (selected !== null) ? selected.value : "");
                                            validationDraft.setFieldValue("id_business_unit", (selected !== null) ? selected.value : "");
                                            validation.setFieldValue("business_unit_other", "");
                                            validationDraft.setFieldValue("business_unit_other", "");
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={validation.touched.id_business_unit && validation.errors.id_business_unit ? true : false}
                                        isDisabled={formIsDisabled || validation.values.is_bu_other !== "0"}
                                    />
                                    { validation.touched.id_business_unit && validation.errors.id_business_unit ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.id_business_unit}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={5}>
                                <FormGroup className="pt-3">
                                    <Input id="cbIsBuOther"
                                        name="is_bu_other"
                                        type="checkbox"
                                        checked={(validation.values.is_bu_other === "1") ? true : false}
                                        onChange={(e) => {
                                            if(e.target.checked === true){
                                                setSelectIdBusinessUnit(null);                                                
                                                validation.setFieldValue("is_bu_other", "1");
                                                validationDraft.setFieldValue("is_bu_other", "1");
                                                validation.setFieldValue("id_business_unit", "-1");
                                                validationDraft.setFieldValue("id_business_unit", "-1");
                                                validation.setFieldValue("business_unit_other", "");
                                                validationDraft.setFieldValue("business_unit_other", "");
                                                validation.setFieldError("id_business_unit", null);
                                                validation.setFieldError("business_unit_other", null);
                                            }else{
                                                setSelectIdBusinessUnit(null);                                                
                                                validation.setFieldValue("is_bu_other", "0");
                                                validationDraft.setFieldValue("is_bu_other", "0");
                                                validation.setFieldValue("id_business_unit", "");
                                                validationDraft.setFieldValue("id_business_unit", "");
                                                validation.setFieldValue("business_unit_other", "");
                                                validationDraft.setFieldValue("business_unit_other", "");
                                                validation.setFieldError("id_business_unit", null);
                                                validation.setFieldError("business_unit_other", null);
                                            }
                                            setIsSaveEnabled(true);
                                        }}
                                        disabled={formIsDisabled}
                                    />
                                    <Label className="label-title" for="cbIsBuOther">อื่นๆ (Others)<span className="msg-require">*</span></Label>
                                    <Input id="txtBusinessUnitOther"
                                        name="business_unit_other"
                                        type="text"
                                        placeholder={(validation.values.is_bu_other === "1") ? "กรอกชื่อบริษัท" : ""}
                                        className="txt-placeholder"
                                        value={(validation.values.id_business_unit > 0) ? "" : validation.values.business_unit_other}
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={validation.touched.business_unit_other && validation.errors.business_unit_other ? true : false}
                                        disabled={formIsDisabled || validation.values.is_bu_other !== "1"}
                                    />
                                    { validation.touched.business_unit_other && validation.errors.business_unit_other ? 
                                        ( <FormFeedback type="invalid">{validation.errors.business_unit_other}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <div className="line-border"></div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <span className="span-title">
                                    วัตถุประสงค์ที่ต้องการเอกสารไปใช้ (Purpose)
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label for="txtForUse" className="label-title">เพื่อนำไปใช้<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightForUse"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="PopoverRightForUse" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtForUse"
                                        name="for_use"
                                        placeholder="Input"
                                        type="textarea"
                                        className="from-control for-use-input"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.for_use || ""}
                                        invalid={validation.touched.for_use && validation.errors.for_use ? true : false}
                                        disabled={formIsDisabled}
                                    />
                                    { validation.touched.for_use && validation.errors.for_use ? 
                                        ( <FormFeedback type="invalid">{validation.errors.for_use}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <Label className="label-title pb-2">เอกสารแนบ (Attachment)<span className="msg-require">*</span></Label><br/>
                                <MultipleUploadfile inputID="fileForUseDoc" folder={dataFormRequest.request_no} dataFile={fileForUseDoc} setDataFile={OnSetFileForUseDoc} isDisable={formIsDisabled}/>
                                { validation.touched.for_use_doc && validation.errors.for_use_doc ? 
                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.for_use_doc}</FormFeedback> ) : false 
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <div className="line-border"></div>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-1-3">
                        <Row>
                            <Col md={12}>
                                <div className="icon-hint-align-left">
                                    <span className="span-title">เอกสารที่ต้องการขอ (Required Document)</span>&nbsp;
                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRight"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="PopoverRight" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดระบุเอกสารที่ต้องการขอและระบุจำนวนเอกสารที่ต้องการสำหรับหนังสือรับรองบริษัท ฝ่ายกฎหมายจะเตรียมฉบับที่อายุไม่เกิน 6 เดือน หากต้องการใช้หนังสือรับรองที่ออกในระยะเวลาที่สั้นกว่านี้ โปรดระบุระยะเวลาที่ต้องการใช้<br />Please specify the documents you need and the number of copies required. For the company affidavit, the Legal Team will prepare an affidavit issued no more than 6 months. If you require a certificate with an issuance date shorter than this, please indicate the duration.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <p className="span-sub-title mt-2 mb-4">สามารถเลือกได้มากกว่า 1 ช่อง</p>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-2-1">
                        <Row>
                            <Col md={12} className="mb-2">
                                <Input id="cbReqDocCert"
                                    type="checkbox"
                                    name="req_doc_cert"
                                    checked={checkBoxDocCert === "1"}
                                    onChange={(e) => {
                                        const value = e.target.checked ? "1" : "0";
                                        setCheckBoxDocCert(value);
                                        validation.handleChange("req_doc_cert")(value);
                                        validationDraft.handleChange("req_doc_cert")(value);
                                        ClearDataDocCert(value);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.req_doc_cert && validation.errors.req_doc_cert ? true : false}
                                    disabled={formIsDisabled}
                                />
                                {/* { console.log(checkBoxDocCert)} */}
                                <Label for="cbReqDocCert" className="label-title-checkbox">1.สำเนาหนังสือรับรอง ของบริษัท (โปรดระบุ)<span className="msg-require">*</span></Label><br/>
                                <Label for="cbReqDocCert" className="label-sub-title-checkbox">Copy of company affidavit (please specify the company)</Label>
                                { validation.touched.req_doc_cert && validation.errors.req_doc_cert ? 
                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.req_doc_cert}</FormFeedback> ) : false 
                                }
                            </Col>
                        </Row>
                    </div>
                    
                    {validation.values.doc_certs.map((item, index) => {
                        const docCertError = validation.errors.doc_certs?.length && validation.errors.doc_certs[index] || {};
                        const docCertTouch = validation.touched.doc_certs?.length && validation.touched.doc_certs[index] || {};
                        return (
                            <div id={"section-page-2-" + (index + 2)} key={"reqDocCert" + index}>
                                <Row>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label className="label-title">บริษัท (BU)<span className="msg-require">*</span></Label>
                                            <Select id={`ddlDocCertBu${index}`}
                                                name={`doc_certs[${index}].doc_cert_bu`}
                                                className="txt-placeholder"
                                                options={dataCompany}
                                                placeholder={(item.is_bu_other === "0") ? "โปรดเลือก..." : ""}
                                                isClearable={true}
                                                isSearchable={true}
                                                value={selectDocCertBu[index]}
                                                onChange={(selected) => {
                                                    let arrSelect = selectDocCertBu;
                                                    arrSelect[index] = selected;
                                                    setSelectDocCertBu(arrSelect);
                                                    validation.setFieldValue(`doc_certs[${index}].doc_cert_bu`, (selected !== null) ? selected.value : "");
                                                    validationDraft.setFieldValue(`doc_certs[${index}].doc_cert_bu`, (selected !== null) ? selected.value : "");
                                                    validation.setFieldValue(`doc_certs[${index}].doc_cert_bu_other`, "");
                                                    validationDraft.setFieldValue(`doc_certs[${index}].doc_cert_bu_other`, "");
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docCertTouch.doc_cert_bu && docCertError.doc_cert_bu ? true : false }
                                                isDisabled={checkBoxDocCert === "0" || formIsDisabled || item.is_bu_other !== "0"}
                                            />
                                            {docCertTouch.doc_cert_bu && docCertError.doc_cert_bu ? (
                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                    {docCertError.doc_cert_bu}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Input id={`cbIsBuOther${index}`}
                                                name={`doc_certs[${index}].is_bu_other`}
                                                type="checkbox"
                                                checked={(item.is_bu_other === "1") ? true : false}
                                                onChange={(e) => {
                                                    if(e.target.checked === true){
                                                        // const newItemSelect = selectDocCertBu.filter((_, i) => i !== index);
                                                        // setSelectDocCertBu(newItemSelect);
                                                        let arrSelect = selectDocCertBu;
                                                        arrSelect[index] = null;
                                                        setSelectDocCertBu(arrSelect);
                                                        validation.setFieldValue(`doc_certs[${index}].is_bu_other`, "1");
                                                        validationDraft.setFieldValue(`doc_certs[${index}].is_bu_other`, "1");
                                                        validation.setFieldValue(`doc_certs[${index}].doc_cert_bu`, "-1");
                                                        validationDraft.setFieldValue(`doc_certs[${index}].doc_cert_bu`, "-1");
                                                        validation.setFieldValue(`doc_certs[${index}].doc_cert_bu_other`, "");
                                                        validationDraft.setFieldValue(`doc_certs[${index}].doc_cert_bu_other`, "");
                                                        validation.setFieldError(`doc_certs[${index}].doc_cert_bu`, null);
                                                        validation.setFieldError(`doc_certs[${index}].doc_cert_bu_other`, null);
                                                    }else{
                                                        // const newItemSelect = selectDocCertBu.filter((_, i) => i !== index);
                                                        // setSelectDocCertBu(newItemSelect);
                                                        let arrSelect = selectDocCertBu;
                                                        arrSelect[index] = null;
                                                        setSelectDocCertBu(arrSelect);
                                                        validation.setFieldValue(`doc_certs[${index}].is_bu_other`, "0");
                                                        validationDraft.setFieldValue(`doc_certs[${index}].is_bu_other`, "0");
                                                        validation.setFieldValue(`doc_certs[${index}].doc_cert_bu`, "");
                                                        validationDraft.setFieldValue(`doc_certs[${index}].doc_cert_bu`, "");
                                                        validation.setFieldValue(`doc_certs[${index}].doc_cert_bu_other`, "");
                                                        validationDraft.setFieldValue(`doc_certs[${index}].doc_cert_bu_other`, "");
                                                        validation.setFieldError(`doc_certs[${index}].doc_cert_bu`, null);
                                                        validation.setFieldError(`doc_certs[${index}].doc_cert_bu_other`, null);
                                                    }
                                                    setIsSaveEnabled(true);
                                                }}
                                                disabled={checkBoxDocCert === "0" || formIsDisabled}
                                            />
                                            <Label className="label-title" for={`cbIsBuOther${index}`}>อื่นๆ (Others)<span className="msg-require">*</span></Label>
                                            <Input id={`txtBusinessUnitOther${index}`}
                                                name={`doc_certs[${index}].doc_cert_bu_other`}
                                                type="text"
                                                placeholder={(item.is_bu_other === "1") ? "กรอกชื่อบริษัท" : ""}
                                                className="txt-placeholder"
                                                // value={(item.doc_cert_bu > 0) ? "" : item.doc_cert_bu_other}
                                                value={item.doc_cert_bu_other}
                                                onChange={(e) => {
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docCertTouch.doc_cert_bu_other && docCertError.doc_cert_bu_other ? true : false }
                                                disabled={checkBoxDocCert === "0" || formIsDisabled || item.is_bu_other !== "1"}
                                            />
                                            {docCertTouch.doc_cert_bu_other && docCertError.doc_cert_bu_other ? (
                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                    {docCertError.doc_cert_bu_other}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    {/* <Col md={1} className="d-flex justify-content-start align-items-center icon-inline">
                                        <FormGroup>
                                            {index === 0 && validation.values.doc_certs.length < 5 ? (
                                                <i className={`mdi mdi-plus-circle ${checkBoxDocCert === "0" || formIsDisabled ? "icon-disabled" : "icon-plus"}`}  onClick={checkBoxDocCert === "0" || formIsDisabled ? null : OnClickAddDocCert}  ></i>
                                            ) : (
                                                index === 0 && validation.values.doc_certs.length === 5 && ( 
                                                    <i className="mdi mdi-plus-circle icon-disabled" onClick={null}></i>
                                                )
                                            )}
                                            {index > 0 && (
                                                <i className={`mdi mdi-minus-circle ${checkBoxDocCert === "0" || formIsDisabled ? "icon-disabled" : "icon-minus"}`} onClick={checkBoxDocCert === "0" || formIsDisabled ? null : () => OnClickRemoveDocCert(index)} ></i>
                                            )}
                                        </FormGroup>
                                    </Col> */}
                                </Row>
                                <Row>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label for={`txtDocCertBuExpire${index}`} className="label-title">อายุของหนังสือรับรอง</Label>
                                            <i className="mdi mdi-help-circle icon-hint-right" id={`prDocCertBuExpire${index}`}></i>
                                            <div className="hstack flex-wrap gap-2">
                                                <UncontrolledPopover placement="right" target={`prDocCertBuExpire${index}`} >
                                                    <PopoverBody className="msg-show-hint">
                                                        <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                        หากไม่ระบุเท่ากับใช้อายุไม่เกิน 6 เดือน<br/>If not specified, it shall be deemed to have a validity period of not more than 6 months. 
                                                    </PopoverBody>
                                                </UncontrolledPopover>
                                            </div>
                                            <Input id={`txtDocCertBuExpire${index + 1}`}
                                                type="text"
                                                name={`doc_certs[${index}].doc_cert_bu_expire`}
                                                placeholder="ระบุอายุของหนังสือรับรอง"
                                                className="txt-placeholder"
                                                value={item.doc_cert_bu_expire}
                                                onChange={(e) => {
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docCertTouch.doc_cert_bu_expire && docCertError.doc_cert_bu_expire ? true : false }
                                                disabled={checkBoxDocCert === "0" || formIsDisabled}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label for={`docCertAmount${index}`} className="label-title">จำนวน (Copies)<span className="msg-require">*</span></Label>
                                            <Input id={`docCertAmount${index}`}
                                                type="text"
                                                name={`doc_certs[${index}].doc_cert_amount`}
                                                placeholder="จำนวนเอกสาร"
                                                className="txt-placeholder"
                                                value={item.doc_cert_amount}
                                                onChange={(e) => {
                                                    ValidateNumber(e);
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docCertTouch.doc_cert_amount && docCertError.doc_cert_amount ? true : false }
                                                disabled={checkBoxDocCert === "0" || formIsDisabled}
                                            />
                                            {docCertTouch.doc_cert_amount && docCertError.doc_cert_amount ? (
                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                    {docCertError.doc_cert_amount}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        );
                    })}
                    <div id="section-page-3-1">
                        <Row>
                            <Col md={12} className="mt-3 mb-2">
                                <Input id="cbReqDocIdcardHouse"
                                    name="req_doc_idcard_house"
                                    type="checkbox"
                                    checked={checkBoxIdCard === "1"}
                                    onChange={(e) => {
                                        const value = e.target.checked ? "1" : "0";
                                        setCheckBoxIdCard(value);
                                        validation.handleChange("req_doc_idcard_house")(value);
                                        validationDraft.handleChange("req_doc_idcard_house")(value);
                                        ClearDataIdCard(value);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    disabled={formIsDisabled}
                                />
                                <Label for="cbReqDocIdcardHouse" className="label-title-checkbox">2.สำเนาบัตรประชาชนและ/หรือทะเบียนบ้าน (โปรดระบุชื่อ)</Label><br/>
                                <Label for="cbReqDocIdcardHouse" className="label-sub-title-checkbox">Copy of ID Card and/or house registration  (please specify the name)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} className="mb-2">
                                <div className="label-ddl">
                                    <div className="form-check form-check-inline label-sub-content-checkbox">
                                        <Input id="cbDocIdcardType"
                                            name="doc_idcard_type"
                                            type="radio"
                                            className="form-check-input"
                                            checked={rdDocIsIdCardType === "0"}
                                            onChange={(e) => {
                                                // const value = e.target.checked ? "1" : "0";
                                                setRdDocIsIdCardType("0");
                                                setCbDocIdcardType("1");
                                                setCbDocIdcardHouseType("0");
                                                validation.handleChange("doc_idcard_type")("1");
                                                validationDraft.handleChange("doc_idcard_type")("1");
                                                validation.handleChange("doc_idcard_house_type")("0");
                                                validationDraft.handleChange("doc_idcard_house_type")("0");
                                                ClearDataSubIdCardType("1");
                                                ClearDataSubIdCardHouseType("0");
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            disabled={checkBoxIdCard === "0" || formIsDisabled}
                                            invalid={ validation.touched.doc_idcard_type && validation.errors.doc_idcard_type ? true : false }
                                        />
                                        <Label className="form-check-label" for="cbDocIdcardType">
                                            บัตรประชาชนอย่างเดียว (ID Card)
                                        </Label>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    {validation.values.doc_idcards.map((item, index) => {
                        const docIdcardError = validation.errors.doc_idcards?.length && validation.errors.doc_idcards[index] || {};
                        const docIdcardTouch = validation.touched.doc_idcards?.length && validation.touched.doc_idcards[index] || {};
                        return (
                            <Row id={"section-page-3-" + (index + 2)} key={"DocIdcard"+index}>
                                <Col md={7}>
                                    <FormGroup>
                                        <Label for={`txtDocIdcardName${index}`} className="label-title">ชื่อ (Name)<span className="msg-require">*</span></Label>
                                        <Input id={`txtDocIdcardName${index}`}
                                            name={`doc_idcards[${index}].doc_idcard_name`}
                                            type="text"
                                            className="txt-placeholder"
                                            placeholder="กรอกชื่อ"
                                            value={item.doc_idcard_name}
                                            onChange={(e) => {
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            invalid={docIdcardTouch.doc_idcard_name && docIdcardError.doc_idcard_name ? true : false}
                                            disabled={(checkBoxIdCard === "0" || cbDocIdcardType === "0") || formIsDisabled}
                                        />
                                        {docIdcardTouch.doc_idcard_name && docIdcardError.doc_idcard_name ? (
                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                {docIdcardError.doc_idcard_name}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for={`txtDocIdcardAmount${index}`} className="label-title">จำนวน (Copies)<span className="msg-require">*</span></Label>
                                        <Input id={`txtDocIdcardAmount${index}`}
                                            name={`doc_idcards[${index}].doc_idcard_amount`}
                                            type="text"
                                            className="txt-placeholder"
                                            placeholder="จำนวนเอกสาร"
                                            value={item.doc_idcard_amount}
                                            onChange={(e) => {
                                                ValidateNumber(e);
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            invalid={docIdcardTouch.doc_idcard_amount && docIdcardError.doc_idcard_amount ? true : false}
                                            disabled={(checkBoxIdCard === "0" || cbDocIdcardType === "0") || formIsDisabled}
                                        />
                                        {docIdcardTouch.doc_idcard_amount && docIdcardError.doc_idcard_amount ? (
                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                {docIdcardError.doc_idcard_amount}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col md={1} className="d-flex justify-content-start align-items-center icon-inline">
                                    {index === 0 && validation.values.doc_idcards.length < 5 ? (
                                        <i className={`mdi mdi-plus-circle ${(checkBoxIdCard === "0" || cbDocIdcardType === "0") || formIsDisabled ? "icon-disabled" : "icon-plus"}`}  onClick={(checkBoxIdCard === "0" || cbDocIdcardType === "0") || formIsDisabled ? null : OnClickAddDocIdCard}  ></i>
                                    ) : (
                                        index === 0 && validation.values.doc_idcards.length === 5 && ( 
                                            <i className="mdi mdi-plus-circle icon-disabled" onClick={null}></i>
                                        )
                                    )}
                                    {index > 0 && (
                                        <i className={`mdi mdi-minus-circle ${(checkBoxIdCard === "0" || cbDocIdcardType === "0") || formIsDisabled ? "icon-disabled" : "icon-minus"}`} onClick={(checkBoxIdCard === "0" || cbDocIdcardType === "0") || formIsDisabled ? null : () => OnClickRemoveDocIdCard(index)} ></i>
                                    )}
                                </Col>
                            </Row>
                        );
                    })}
                    <div id="section-page-3-10">
                        <Row>
                            <Col md={12} className="mb-1">
                                <div className="label-ddl">    
                                    <div className="form-check form-check-inline label-sub-content-checkbox">
                                        <Input id="cbDocIdcardHouseType"
                                            name="doc_idcard_house_type"
                                            type="radio"
                                            className="form-check-input"
                                            checked={rdDocIsIdCardType === "1"}
                                            onChange={(e) => {
                                                // const value = e.target.checked ? "1" : "0";
                                                setRdDocIsIdCardType("1");
                                                setCbDocIdcardType("0");
                                                setCbDocIdcardHouseType("1");
                                                validation.handleChange("doc_idcard_type")("0");
                                                validationDraft.handleChange("doc_idcard_type")("0");
                                                validation.handleChange("doc_idcard_house_type")("1");
                                                validationDraft.handleChange("doc_idcard_house_type")("1");
                                                ClearDataSubIdCardType("0");
                                                ClearDataSubIdCardHouseType("1");
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            disabled={checkBoxIdCard === "0" || formIsDisabled}
                                            invalid={ validation.touched.doc_idcard_house_type && validation.errors.doc_idcard_house_type ? true : false }
                                        />
                                        <Label className="form-check-label" htmlFor="cbDocIdcardHouseType">
                                            บัตรประชาชนและทะเบียนบ้าน (ID Card and House Registration)
                                        </Label>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    {validation.values.doc_idcard_houses.map((item, index) => {
                        const docIdcardHouseError = validation.errors.doc_idcard_houses?.length && validation.errors.doc_idcard_houses[index] || {};
                        const docIdcardHouseTouch = validation.touched.doc_idcard_houses?.length && validation.touched.doc_idcard_houses[index] || {};
                        return (
                            <Row id={"section-page-3-" + (index + 11)} key={"DocIdcardHouse"+index}>
                                <Col md={7}>
                                    <FormGroup>
                                        <Label className="label-title">ชื่อ (Name)<span className="msg-require">*</span></Label>
                                        <Input id={`t${index}`}
                                            name={`doc_idcard_houses[${index}].doc_idcard_house_name`}
                                            type="text"
                                            className="txt-placeholder"
                                            placeholder="กรอกชื่อ"
                                            value={item.doc_idcard_house_name}
                                            onChange={(e) => {
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            invalid={docIdcardHouseTouch.doc_idcard_house_name && docIdcardHouseError.doc_idcard_house_name ? true : false}
                                            disabled={(checkBoxIdCard === "0" || cbDocIdcardHouseType === "0") || formIsDisabled}
                                        />
                                        {docIdcardHouseTouch.doc_idcard_house_name && docIdcardHouseError.doc_idcard_house_name ? (
                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                {docIdcardHouseError.doc_idcard_house_name}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                    
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label className="label-title">จำนวน (Copies)<span className="msg-require">*</span></Label>
                                        <Input id={`t${index}`}
                                            name={`doc_idcard_houses[${index}].doc_idcard_house_amount`}
                                            type="text"
                                            className="txt-placeholder"
                                            placeholder="จำนวนเอกสาร"
                                            value={item.doc_idcard_house_amount}
                                            onChange={(e) => {
                                                ValidateNumber(e);
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            invalid={docIdcardHouseTouch.doc_idcard_house_amount && docIdcardHouseError.doc_idcard_house_amount ? true : false}
                                            disabled={(checkBoxIdCard === "0" || cbDocIdcardHouseType === "0") || formIsDisabled}
                                        />
                                        {docIdcardHouseTouch.doc_idcard_house_amount && docIdcardHouseError.doc_idcard_house_amount ? (
                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                {docIdcardHouseError.doc_idcard_house_amount}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col md={1} className="d-flex justify-content-start align-items-center icon-inline">
                                    {index === 0 && validation.values.doc_idcard_houses.length < 5 ? (
                                        <i className={`mdi mdi-plus-circle ${(checkBoxIdCard === "0" || cbDocIdcardHouseType === "0") || formIsDisabled ? "icon-disabled" : "icon-plus"}`}  onClick={(checkBoxIdCard === "0" || cbDocIdcardHouseType === "0") || formIsDisabled ? null : OnClickAddDocIdCardHouse}  ></i>
                                    ) : (
                                        index === 0 && validation.values.doc_idcard_houses.length === 5 && ( 
                                            <i className="mdi mdi-plus-circle icon-disabled" onClick={null}></i>
                                        )
                                    )}
                                    {index > 0 && (
                                        <i className={`mdi mdi-minus-circle ${(checkBoxIdCard === "0" || cbDocIdcardHouseType === "0") || formIsDisabled ? "icon-disabled" : "icon-minus"}`} onClick={(checkBoxIdCard === "0" || cbDocIdcardHouseType === "0") || formIsDisabled ? null : () => OnClickRemoveDocIdCardHouse(index)} ></i>
                                    )}
                                </Col>
                            </Row>
                        );
                    })}
                    <div id="section-page-4-1">
                        <Row>
                            <Col md={12} className="mt-3 mb-2">
                                <Input id="cbReqDocPassport"
                                    type="checkbox"
                                    name="req_doc_passport"
                                    checked={checkBoxPassport === "1"}
                                    onChange={(e) => {
                                        const value = e.target.checked ? "1" : "0";
                                        validation.setFieldValue("req_doc_passport", value);
                                        setCheckBoxPassport(value);
                                        validation.handleChange("req_doc_passport")(value);
                                        validationDraft.handleChange("req_doc_passport")(value);
                                        ClearDataPassport(value);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.req_doc_passport && validation.errors.req_doc_passport ? true : false}
                                    disabled={formIsDisabled}
                                />
                                <Label for="cbReqDocPassport" className="label-title-checkbox">3.สำเนาหนังสือเดินทาง (โปรดระบุชื่อ)</Label><br/>
                                <Label for="cbReqDocPassport" className="label-sub-title-checkbox">Copy of passport (please specify the name)</Label>
                            </Col>
                        </Row>
                    </div>
                    {validation.values.doc_passports.map((item, index) => {
                        const docPassportError = validation.errors.doc_passports?.length && validation.errors.doc_passports[index] || {};
                        const docPassportTouch = validation.touched.doc_passports?.length && validation.touched.doc_passports[index] || {};
                        return (
                            <Row id={"section-page-4-" + (index + 2)} key={"docPassport" + index}>
                                <Col md={7}>
                                    <FormGroup>
                                        <Label className="label-title">ชื่อ (Name)<span className="msg-require">*</span></Label>
                                        <Input id={`txtDocPassportName${index}`}
                                            name={`doc_passports[${index}].doc_passport_name`}
                                            type="text"
                                            className="txt-placeholder"
                                            placeholder="กรอกชื่อ"
                                            value={item.doc_passport_name}
                                            onChange={(e) => {
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            invalid={docPassportTouch.doc_passport_name && docPassportError.doc_passport_name ? true : false}
                                            disabled={checkBoxPassport === "0" || formIsDisabled}
                                        />
                                        {docPassportTouch.doc_passport_name && docPassportError.doc_passport_name ? (
                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                {docPassportError.doc_passport_name}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label className="label-title">จำนวน (Copies)<span className="msg-require">*</span></Label>
                                        <Input id={`txtDocPassportAmount${index}`}
                                            name={`doc_passports[${index}].doc_passport_amount`}
                                            type="text"
                                            placeholder="จำนวนเอกสาร"
                                            className="txt-placeholder"
                                            value={item.doc_passport_amount}
                                            onChange={(e) => {
                                                ValidateNumber(e);
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            invalid={docPassportTouch.doc_passport_amount && docPassportError.doc_passport_amount ? true : false}
                                            disabled={checkBoxPassport === "0" || formIsDisabled}
                                        />
                                        {docPassportTouch.doc_passport_amount && docPassportError.doc_passport_amount ? (
                                            <FormFeedback type="invalid" style={{display: "block", whiteSpace: "pre-line"}} className="msg-show-hint">
                                                {docPassportError.doc_passport_amount}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col md={1} className="d-flex justify-content-start align-items-center icon-inline">
                                    {index === 0 && validation.values.doc_passports.length < 5 ? (
                                        <i className={`mdi mdi-plus-circle ${checkBoxPassport === "0" || formIsDisabled ? "icon-disabled" : "icon-plus"}`}  onClick={checkBoxPassport === "0" || formIsDisabled ? null : OnClickAddDocPassport}  ></i>
                                    ) : (
                                        index === 0 && validation.values.doc_passports.length === 5 && ( 
                                            <i className="mdi mdi-plus-circle icon-disabled" onClick={null}></i>
                                        )
                                    )}
                                    {index > 0 && (
                                        <i className={`mdi mdi-minus-circle ${checkBoxPassport === "0" || formIsDisabled ? "icon-disabled" : "icon-minus"}`} onClick={checkBoxPassport === "0" || formIsDisabled ? null : () => OnClickRemovePassport(index)} ></i>
                                    )}
                                </Col>
                            </Row>
                        );
                    })}
                    <div id="section-page-5-1">
                        <Row>
                            <Col md={12} className="mt-3 mb-2">
                                <Input id="cbReqDocShareHolders"
                                    name="req_doc_shareholders"
                                    type="checkbox"
                                    checked={checkBoxShareholders === "1"}
                                    onChange={(e) => {
                                        // Handle validation changes (if needed)
                                        const value = e.target.checked ? "1" : "0";
                                        setCheckBoxShareholders(value);
                                        validation.handleChange("req_doc_shareholders")(value);
                                        validationDraft.handleChange("req_doc_shareholders")(value);
                                        ClearDataShareholder(value);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.req_doc_shareholders && validation.errors.req_doc_shareholders ? true : false}
                                    disabled={formIsDisabled}
                                />
                                <Label for="cbReqDocShareHolders" className="label-title-checkbox">4.สำเนาบัญชีรายชื่อผู้ถือหุ้น (แบบ บอจ.5) ของบริษัท (โปรดระบุ)<span className="msg-require">*</span></Label><br/>
                                <Label for="cbReqDocShareHolders" className="label-sub-title-checkbox">Copy of the list of shareholders (BOJ 5) (please specify the company)</Label>
                            </Col>
                        </Row>
                    </div>
                    {validation.values.doc_shareholders.map((item, index) => {
                        const docShareholderError = validation.errors.doc_shareholders?.length && validation.errors.doc_shareholders[index] || {};
                        const docShareholderTouch = validation.touched.doc_shareholders?.length && validation.touched.doc_shareholders[index] || {};
                        return (
                            <div id={"section-page-5-" + (index + 2)} key={"reqDocShareholder"+index}>
                                <Row>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label className="label-title">บริษัท (BU)<span className="msg-require">*</span></Label>
                                            <Select id={`ddlDocShareholderBu${index}`}
                                                name={`doc_shareholders[${index}].doc_shareholders_bu`}
                                                className="txt-placeholder"
                                                options={dataCompany}
                                                placeholder={(item.is_bu_other === "0") ? "โปรดเลือก..." : ""}
                                                isClearable={true}
                                                isSearchable={true}
                                                value={selectDocShareholderBu[index]}
                                                onChange={(selected) => {
                                                    let arrSelect = selectDocShareholderBu;
                                                    arrSelect[index] = selected;
                                                    setSelectDocShareholderBu(arrSelect);
                                                    validation.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu`, (selected !== null) ? selected.value : "");
                                                    validationDraft.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu`, (selected !== null) ? selected.value : "");
                                                    validation.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu_other`, "");
                                                    validationDraft.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu_other`, "");
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docShareholderTouch.doc_shareholders_bu && docShareholderError.doc_shareholders_bu ? true : false }
                                                isDisabled={checkBoxShareholders === "0" || formIsDisabled || item.is_bu_other !== "0"}
                                            />
                                            {docShareholderTouch.doc_shareholders_bu && docShareholderError.doc_shareholders_bu ? (
                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                    {docShareholderError.doc_shareholders_bu}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Input id={`cbDocShareholderIsBuOther${index}`}
                                                name={`doc_shareholders[${index}].is_bu_other`}
                                                type="checkbox"
                                                checked={(item.is_bu_other === "1") ? true : false}
                                                onChange={(e) => {
                                                    if(e.target.checked === true){
                                                        // const newItemSelect = selectDocShareholderBu.filter((_, i) => i !== index);
                                                        // setSelectDocShareholderBu(newItemSelect);
                                                        let arrSelect = selectDocShareholderBu;
                                                        arrSelect[index] = null;
                                                        setSelectDocShareholderBu(arrSelect);
                                                        validation.setFieldValue(`doc_shareholders[${index}].is_bu_other`, "1");
                                                        validationDraft.setFieldValue(`doc_shareholders[${index}].is_bu_other`, "1");
                                                        validation.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu`, "-1");
                                                        validationDraft.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu`, "-1");
                                                        validation.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu_other`, "");
                                                        validationDraft.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu_other`, "");
                                                        validation.setFieldError(`doc_shareholders[${index}].doc_shareholders_bu`, null);
                                                        validation.setFieldError(`doc_shareholders[${index}].doc_shareholders_bu_other`, null);
                                                    }else{
                                                        // const newItemSelect = selectDocShareholderBu.filter((_, i) => i !== index);
                                                        // setSelectDocShareholderBu(newItemSelect);
                                                        let arrSelect = selectDocShareholderBu;
                                                        arrSelect[index] = null;
                                                        setSelectDocShareholderBu(arrSelect);
                                                        validation.setFieldValue(`doc_shareholders[${index}].is_bu_other`, "0");
                                                        validationDraft.setFieldValue(`doc_shareholders[${index}].is_bu_other`, "0");
                                                        validation.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu`, "");
                                                        validationDraft.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu`, "");
                                                        validation.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu_other`, "");
                                                        validationDraft.setFieldValue(`doc_shareholders[${index}].doc_shareholders_bu_other`, "");
                                                        validation.setFieldError(`doc_shareholders[${index}].doc_shareholders_bu`, null);
                                                        validation.setFieldError(`doc_shareholders[${index}].doc_shareholders_bu_other`, null);
                                                    }
                                                    setIsSaveEnabled(true);
                                                }}
                                                disabled={checkBoxShareholders === "0" || formIsDisabled}
                                            />
                                            <Label className="label-title" for={`cbDocShareholderIsBuOther${index}`}>อื่นๆ (Others)<span className="msg-require">*</span></Label>
                                            <Input id={`txtDocShareholdersBuOther${index}`}
                                                name={`doc_shareholders[${index}].doc_shareholders_bu_other`}
                                                type="text"
                                                placeholder={(item.is_bu_other === "1") ? "กรอกชื่อบริษัท" : ""}
                                                className="txt-placeholder"
                                                value={(item.doc_shareholders_bu > 0) ? "" : item.doc_shareholders_bu_other}
                                                onChange={(e) => {
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docShareholderTouch.doc_shareholders_bu_other && docShareholderError.doc_shareholders_bu_other ? true : false }
                                                disabled={checkBoxShareholders === "0" || formIsDisabled || item.is_bu_other !== "1"}
                                            />
                                            {docShareholderTouch.doc_shareholders_bu_other && docShareholderError.doc_shareholders_bu_other ? (
                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                    {docShareholderError.doc_shareholders_bu_other}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md={1} className="d-flex justify-content-start align-items-center icon-inline">
                                        <FormGroup>
                                            {index === 0 && validation.values.doc_shareholders.length < 5 ? (
                                                <i className={`mdi mdi-plus-circle ${checkBoxShareholders === "0" || formIsDisabled ? "icon-disabled" : "icon-plus"}`}  onClick={checkBoxShareholders === "0" || formIsDisabled ? null : OnClickAddShareholders}  ></i>
                                            ) : (
                                                index === 0 && validation.values.doc_shareholders.length === 5 && ( 
                                                    <i className="mdi mdi-plus-circle icon-disabled" onClick={null}></i>
                                                )
                                            )}
                                            {index > 0 && (
                                                <i className={`mdi mdi-minus-circle ${checkBoxShareholders === "0" || formIsDisabled ? "icon-disabled" : "icon-minus"}`} onClick={checkBoxShareholders === "0" || formIsDisabled ? null : () => OnClickRemoveShareholders(index)} ></i>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label for={`txtDocShareholderExpire${index}`} className="label-title">อายุของบอจ.5</Label>
                                            <i className="mdi mdi-help-circle icon-hint-right" id={`prDocShareholderExpire${index}`}></i>
                                            <div className="hstack flex-wrap gap-2">
                                                <UncontrolledPopover placement="right" target={`prDocShareholderExpire${index}`} >
                                                    <PopoverBody className="msg-show-hint">
                                                        <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                        หากไม่ระบุเท่ากับใช้อายุไม่เกิน 6 เดือน<br/>If not specified, it shall be deemed to have a validity period of not more than 6 months.
                                                    </PopoverBody>
                                                </UncontrolledPopover>
                                            </div>
                                            <Input id={`txtDocShareholderExpire${index + 1}`}
                                                type="text"
                                                name={`doc_shareholders[${index}].doc_shareholders_expire`}
                                                placeholder="ระบุอายุของบอจ.5"
                                                className="txt-placeholder"
                                                value={item.doc_shareholders_expire}
                                                onChange={(e) => {
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docShareholderTouch.doc_shareholders_expire && docShareholderError.doc_shareholders_expire ? true : false }
                                                disabled={checkBoxShareholders === "0" || formIsDisabled}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label for={`docShareholderAmount${index}`} className="label-title">จำนวน (Copies)<span className="msg-require">*</span></Label>
                                            <Input id={`docShareholderAmount${index}`}
                                                name={`doc_shareholders[${index}].doc_shareholders_amount`}
                                                type="text"
                                                placeholder="จำนวนเอกสาร"
                                                className="txt-placeholder"
                                                value={item.doc_shareholders_amount}
                                                min={0}
                                                onChange={(e) => {
                                                    ValidateNumber(e);
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docShareholderTouch.doc_shareholders_amount && docShareholderError.doc_shareholders_amount ? true : false }
                                                disabled={checkBoxShareholders === "0" || formIsDisabled}
                                            />
                                            {docShareholderTouch.doc_shareholders_amount && docShareholderError.doc_shareholders_amount ? (
                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                    {docShareholderError.doc_shareholders_amount}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            
                        );
                    })}
                    <div id="section-page-6-1">
                        <Row>
                            <Col md={12} className="mt-3 mb-2">
                                <Input id="cbReqDocTax"
                                    type="checkbox"
                                    name="req_doc_tax"
                                    checked={checkBoxTax === "1"}
                                    onChange={(e) => {
                                        const value = e.target.checked ? "1" : "0";
                                        setCheckBoxTax(value);
                                        validation.handleChange("req_doc_tax")(value);
                                        validationDraft.handleChange("req_doc_tax")(value);
                                        ClearDataTax(value);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.req_doc_tax && validation.errors.req_doc_tax ? true : false}
                                    disabled={formIsDisabled}
                                />
                                <Label for="cbReqDocTax" className="label-title-checkbox">5.ใบทะเบียนภาษีมูลค่าเพิ่ม (ภพ.20) ของบริษัท (โปรดระบุ)<span className="msg-require">*</span></Label><br/>
                                <Label for="cbReqDocTax" className="label-sub-title-checkbox">Copy of VAT registration certificate (PP20) (please specify the company):</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} className="mb-2">
                                <div className="label-ddl">
                                    <div className="form-check form-check-inline label-sub-content-checkbox">
                                        <Input id="cbDocTaxHeadOfficeType"
                                            name="doc_tax_head_ofiice_type"
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={cbDocTaxHeadOfficeType === "1"}
                                            onChange={(e) => {
                                                const value = e.target.checked ? "1" : "0";
                                                setCbDocTaxHeadOfficeType(value);
                                                validation.handleChange("doc_tax_head_ofiice_type")(value);
                                                validationDraft.handleChange("doc_tax_head_ofiice_type")(value);
                                                ClearDataTaxHeadOfficeType(value);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            disabled={checkBoxTax === "0" || formIsDisabled}
                                        />
                                        <Label className="form-check-label" htmlFor="cbDocTaxHeadOfficeType">
                                            สำนักงานใหญ่ (Head Office)
                                        </Label>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label for="txtDocTaxHeadOfficeAmount" className="label-title">จำนวน (Copies)<span className="msg-require">*</span></Label>
                                    <Input id="txtDocTaxHeadOfficeAmount"
                                        name="doc_tax_head_office_amount"
                                        type="text"
                                        placeholder="จำนวนเอกสาร"
                                        className="txt-placeholder"
                                        value={validation.values.doc_tax_head_office_amount || ""}
                                        min={0}
                                        onChange={(e) => {
                                            ValidateNumber(e);
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={validation.touched.doc_tax_head_office_amount && validation.errors.doc_tax_head_office_amount ? true : false}
                                        disabled={(checkBoxTax === "0" || cbDocTaxHeadOfficeType === "0") || formIsDisabled}
                                    />
                                    {validation.touched.doc_tax_head_office_amount && validation.errors.doc_tax_head_office_amount ? (
                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                            {validation.errors.doc_tax_head_office_amount}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div id="section-page-6-2">
                        <Row>
                            <Col md={12} className="mt-1 mb-2">
                                <div className="label-ddl">
                                    <div className="form-check form-check-inline label-sub-content-checkbox">
                                        <Input id="cbDocTaxBranchType"
                                            name="doc_tax_branch_type"
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={cbDocTaxBranchType === "1"}
                                            onChange={(e) => {
                                                const value = e.target.checked ? "1" : "0";
                                                setCbDocTaxBranchType(value);
                                                validation.handleChange("doc_tax_branch_type")(value);
                                                validationDraft.handleChange("doc_tax_branch_type")(value);
                                                ClearDataTaxBranchType(value);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            disabled={checkBoxTax === "0" || formIsDisabled}
                                            />
                                        <Label className="form-check-label" htmlFor="cbDocTaxBranchType">
                                            สาขา Branch(es)
                                        </Label>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    {validation.values.doc_tax_branchs.map((item, index) => {
                        const docTaxBranchError = validation.errors.doc_tax_branchs?.length && validation.errors.doc_tax_branchs[index] || {};
                        const docTaxBranchTouch = validation.touched.doc_tax_branchs?.length && validation.touched.doc_tax_branchs[index] || {};

                        return (
                            <Row id={"section-page-6-" + (index + 3)} key={"reqDocTaxBranch"+index}>
                                <Col md={7}>
                                    <FormGroup>
                                        <Label className="label-title">ระบุสาขา<span className="msg-require">*</span></Label>
                                        <Input id={`txtDocTaxBranchName${index}`}
                                            name={`doc_tax_branchs[${index}].doc_tax_branch_name`}
                                            type="text"
                                            placeholder="สาขา"
                                            className="txt-placeholder"
                                            value={item.doc_tax_branch_name}
                                            onChange={(e) => {
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            invalid={ docTaxBranchTouch.doc_tax_branch_name && docTaxBranchError.doc_tax_branch_name ? true : false }
                                            disabled={(checkBoxTax === "0" || cbDocTaxBranchType === "0") || formIsDisabled}
                                        />
                                        {docTaxBranchTouch.doc_tax_branch_name && docTaxBranchError.doc_tax_branch_name ? (
                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                {docTaxBranchError.doc_tax_branch_name}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label className="label-title">จำนวน (Copies)<span className="msg-require">*</span></Label>
                                        <Input id={`txtDocTaxBranchAmount${index + 1}`}
                                            name={`doc_tax_branchs[${index}].doc_tax_branch_amount`}
                                            type="text"
                                            placeholder="จำนวนเอกสาร"
                                            className="txt-placeholder"
                                            value={item.doc_tax_branch_amount}
                                            min={0}
                                            onChange={(e) => {
                                                ValidateNumber(e);
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            invalid={ docTaxBranchTouch.doc_tax_branch_amount && docTaxBranchError.doc_tax_branch_amount ? true : false }
                                            disabled={(checkBoxTax === "0" || cbDocTaxBranchType === "0") || formIsDisabled}
                                        />
                                        {docTaxBranchTouch.doc_tax_branch_amount && docTaxBranchError.doc_tax_branch_amount ? (
                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                {docTaxBranchError.doc_tax_branch_amount}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col md={1} className="d-flex justify-content-start align-items-center icon-inline">
                                    {index === 0 && validation.values.doc_tax_branchs.length < 5 ? (
                                        <i className={`mdi mdi-plus-circle ${(checkBoxTax === "0" || cbDocTaxBranchType === "0") || formIsDisabled ? "icon-disabled" : "icon-plus"}`}  onClick={(checkBoxTax === "0" || cbDocTaxBranchType === "0") || formIsDisabled ? null : OnClickAddDocTaxBranch}  ></i>
                                    ) : (
                                        index === 0 && validation.values.doc_tax_branchs.length === 5 && ( 
                                            <i className="mdi mdi-plus-circle icon-disabled" onClick={null}></i>
                                        )
                                    )}
                                    {index > 0 && (
                                        <i className={`mdi mdi-minus-circle ${(checkBoxTax === "0" || cbDocTaxBranchType === "0") || formIsDisabled ? "icon-disabled" : "icon-minus"}`} onClick={(checkBoxTax === "0" || cbDocTaxBranchType === "0") || formIsDisabled ? null : () => OnClickRemoveDocTaxBranch(index)} ></i>
                                    )}
                                </Col>
                            </Row>
                        );
                    })}
                    <div id="section-page-7-1">
                        <Row>
                            <Col md={12} className="mt-3 mb-2">
                                <Input id="cbReqDocOther"
                                    name="req_doc_other"
                                    type="checkbox"
                                    checked={checkBoxOther === "1"}
                                    onChange={(e) => {
                                        const value = e.target.checked ? "1" : "0";
                                        setCheckBoxOther(value);
                                        validation.handleChange("req_doc_other")(value);
                                        validationDraft.handleChange("req_doc_other")(value);
                                        ClearDataDocOther(value);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.req_doc_other && validation.errors.req_doc_other ? true : false}
                                    disabled={formIsDisabled}
                                />
                                <Label for="cbReqDocOther" className="label-title-checkbox">6. อื่นๆ (ไม่รวมรายงานการประชุม)</Label><br/>
                                <Label className="label-sub-title-checkbox">Other documents (Excluding the minutes of meeting)&nbsp;&nbsp;
                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightOther"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="PopoverRightOther" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดระบุว่าต้องใช้เอกสารประกอบอื่นใดที่ขอจากฝ่ายกฎหมายอีกบ้าง เช่น บอจ.4, หนังสือบริคณห์สนธิ, ข้อบังคับบริษัท, บอจ.3และ ระบุเหตุผลที่ต้องการใช้<br />Please specify any additional supporting documents required from the Legal Team, such as; Bor Aor Jor 4 (Amendment to the registration), Memorandum of Association, Articles of Association, Bor Aor Jor 3 (company registration form).
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                </Label>
                            </Col>
                        </Row>
                    </div>
                    {validation.values.doc_others.map((item, index) => {
                        const docOtherError = validation.errors.doc_others?.length && validation.errors.doc_others[index] || {};
                        const docOtherTouch = validation.touched.doc_others?.length && validation.touched.doc_others[index] || {};
                        return (
                            <div id={"section-page-7-" + (index + 2)} key={"formDocOther"+index}>
                                <Row>
                                    <Col md={10}>
                                        <FormGroup>
                                            <Label className="label-title">ชื่อเอกสาร (Documents Name)<span className="msg-require">*</span></Label>
                                            <Input id={`txtDocOtherName${index + 1}`}
                                                type="text"
                                                name={`doc_others[${index}].doc_other_name`}
                                                placeholder="ระบุชื่อเอกสาร"
                                                className="txt-placeholder"
                                                value={item.doc_other_name}
                                                onChange={(e) => {
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docOtherTouch.doc_other_name && docOtherError.doc_other_name ? true : false }
                                                disabled={checkBoxOther === "0" || formIsDisabled}
                                            />
                                            {docOtherTouch.doc_other_name && docOtherError.doc_other_name ? (
                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                    {docOtherError.doc_other_name}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md={1} className="d-flex justify-content-start align-items-center icon-inline">
                                        {index === 0 && validation.values.doc_others.length < 10 ? (
                                            <i className={`mdi mdi-plus-circle ${checkBoxOther === "0" || formIsDisabled ? "icon-disabled" : "icon-plus"}`}  onClick={checkBoxOther === "0" || formIsDisabled ? null : OnCLickAddOther}  ></i>
                                        ) : (
                                            index === 0 && validation.values.doc_others.length === 10 && ( 
                                                <i className="mdi mdi-plus-circle icon-disabled" onClick={null}></i>
                                            )
                                        )}
                                        {index > 0 && (
                                            <i className={`mdi mdi-minus-circle ${checkBoxOther === "0" || formIsDisabled ? "icon-disabled" : "icon-minus"}`} onClick={checkBoxOther === "0" || formIsDisabled ? null : () => OnClickRemoveOther(index)} ></i>
                                        )}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label for={`txtDocOtherExpire${index}`} className="label-title">อายุของเอกสาร</Label>
                                            <i className="mdi mdi-help-circle icon-hint-right" id={`prDocOtherExpire${index}`}></i>
                                            <div className="hstack flex-wrap gap-2">
                                                <UncontrolledPopover placement="right" target={`prDocOtherExpire${index}`} >
                                                    <PopoverBody className="msg-show-hint">
                                                        <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                        หากไม่ระบุเท่ากับใช้อายุไม่เกิน 6 เดือน<br/>If not specified, it shall be deemed to have a validity period of not more than 6 months.
                                                    </PopoverBody>
                                                </UncontrolledPopover>
                                            </div>
                                            <Input id={`txtDocOtherExpire${index + 1}`}
                                                type="text"
                                                name={`doc_others[${index}].doc_other_expire`}
                                                placeholder="ระบุอายุของเอกสาร"
                                                className="txt-placeholder"
                                                value={item.doc_other_expire}
                                                onChange={(e) => {
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docOtherTouch.doc_other_expire && docOtherError.doc_other_expire ? true : false }
                                                disabled={checkBoxOther === "0" || formIsDisabled}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label for={`docOtherAmount${index}`} className="label-title">จำนวน (Copies)<span className="msg-require">*</span></Label>
                                            <Input id={`docOtherAmount${index}`}
                                                type="text"
                                                name={`doc_others[${index}].doc_other_amount`}
                                                placeholder="จำนวนเอกสาร"
                                                className="txt-placeholder"
                                                value={item.doc_other_amount}
                                                onChange={(e) => {
                                                    ValidateNumber(e);
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docOtherTouch.doc_other_amount && docOtherError.doc_other_amount ? true : false }
                                                disabled={checkBoxOther === "0" || formIsDisabled}
                                            />
                                            {docOtherTouch.doc_other_amount && docOtherError.doc_other_amount ? (
                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                    {docOtherError.doc_other_amount}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={10}>
                                        <FormGroup>
                                            <Label className="label-title">เหตุผลที่ต้องใช้ (Reason)<span className="msg-require">*</span></Label>
                                            <Input id={`txtDocOtherName${index + 1}`}
                                                type="text"
                                                name={`doc_others[${index}].doc_other_reason`}
                                                placeholder="ระบุเหตุผล"
                                                className="txt-placeholder"
                                                value={item.doc_other_reason}
                                                onChange={(e) => {
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true);
                                                }}
                                                onBlur={validation.handleBlur}
                                                invalid={ docOtherTouch.doc_other_reason && docOtherError.doc_other_reason ? true : false }
                                                disabled={checkBoxOther === "0" || formIsDisabled}
                                            />
                                            {docOtherTouch.doc_other_reason && docOtherError.doc_other_reason ? (
                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                    {docOtherError.doc_other_reason}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>                                        
                                    </Col>
                                </Row>
                            </div>
                        );
                    })}
                    <div id="section-page-7-12">
                        <Row>
                            <Col md={12}>
                                <div className="line-border"></div>
                            </Col>
                        </Row>
                    </div>
                    {(validation.values.is_more_one_copy === "true") ? (
                        <div id="section-page-7-13">
                            <Row>
                                <Col md={12}>
                                    <span className="span-title">
                                        มีการขอเอกสารมากกว่า 1 ชุด
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={10} className="mt-3">
                                    <FormGroup>
                                        <Label className="label-title">
                                            กรุณาระบุเหตุผลที่ขอเอกสารมากกว่า 1 ชุด <br />
                                            Please specify the reason for requesting more than 1 copy of the document. <span className="msg-require">*</span>
                                        </Label>
                                        <Input id="txtReasonMoreOneCopy"
                                            type="textarea"
                                            name="reason_more_one_copy"
                                            placeholder="กรุณาระบุเหตุผล"
                                            className="txt-placeholder"
                                            rows="3"
                                            value={validation.values.reason_more_one_copy || ""}
                                            onChange={(e) => {
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                setIsSaveEnabled(true);
                                            }}
                                            onBlur={validation.handleBlur}
                                            invalid={ validation.touched.reason_more_one_copy && validation.errors.reason_more_one_copy ? true : false }
                                            disabled={formIsDisabled}
                                        />
                                        {validation.touched.reason_more_one_copy && validation.errors.reason_more_one_copy ? (
                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                {validation.errors.reason_more_one_copy}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="line-border"></div>
                                </Col>
                            </Row>
                        </div>
                    ): null}
                    <div id="section-page-8-1">
                        <Row>
                            <Col md={12}>
                                <span className="span-title">
                                    การรับรองสำเนาถูกต้อง (Certified True Copy)
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10} className="mt-3">
                                <FormGroup>
                                    <Label className="label-title">ต้องการรับรองสำเนาถูกต้องหรือไม่ (Certified True Copy)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-padding" id="prCertifiedTrueCopy"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prCertifiedTrueCopy" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i>
                                                หากเลือกต้องการรับรองสำเนาถูกต้อง ต้องแนบไฟล์ Memo สำหรับเสนอลงนามด้วย
                                                <br />Memo is required if user requests for certified true copy.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <div className="pt-3 label-ddl">
                                        <div className="form-check form-check-inline">
                                            <Input id="rdCertifiedTrueCopyYes"
                                                className="form-check-input"
                                                type="radio"
                                                name="certified_true_copy"
                                                checked={rdCertifiedTrueCopy === "1"}
                                                onChange={(e) => {
                                                    setRdCertifiedTrueCopy("1");
                                                    validation.handleChange("certified_true_copy")("1");
                                                    validationDraft.handleChange("certified_true_copy")("1");
                                                    setIsSaveEnabled(true);
                                                }}
                                                disabled={formIsDisabled}
                                            />
                                            <Label className="form-check-label" for="rdCertifiedTrueCopyYes">
                                                รับรองสำเนาถูกต้อง (Certified true copy)
                                            </Label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <Input id="rdCertifiedTrueCopyNo"
                                                className="form-check-input"
                                                type="radio"
                                                name="certified_true_copy"
                                                checked={rdCertifiedTrueCopy === "0"}
                                                onChange={(e) => {
                                                    setRdCertifiedTrueCopy("0");
                                                    validation.handleChange("certified_true_copy")("0");
                                                    validationDraft.handleChange("certified_true_copy")("0");
                                                    validation.handleChange("memo_doc")("");
                                                    validationDraft.handleChange("memo_doc")("");
                                                    setFileMemoDoc([]);
                                                    setIsSaveEnabled(true);
                                                }}
                                                disabled={formIsDisabled}
                                            />
                                            <Label className="form-check-label" for="rdCertifiedTrueCopyNo">
                                                ไม่รับรองสำเนาถูกต้อง (Not certified as a true copy)
                                            </Label>
                                            <i className="mdi mdi-help-circle icon-hint-padding" id="prCertifiedTrueCopyNo"></i>
                                            <div className="hstack flex-wrap gap-2">
                                                <UncontrolledPopover placement="right" target="prCertifiedTrueCopyNo" >
                                                    <PopoverBody className="msg-show-hint">
                                                        <i className="mdi mdi-help-circle msg-icon-hint"></i>
                                                        กรณีที่เลือกไม่รับรองสำเนาถูกต้องทางผู้ขอจะต้องเป็นผู้ดำเนินการเสนอลงนามเอกสารเอง
                                                        <br />If this option is selected, user is responsible for proceeding to have the document certified as a true copy.                                                        
                                                    </PopoverBody>
                                                </UncontrolledPopover>
                                            </div>
                                        </div>
                                    </div>
                                    {validation.touched.certified_true_copy && validation.errors.certified_true_copy ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }}>
                                            {validation.errors.certified_true_copy}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    {validation.values.certified_true_copy === "1" ? (
                        <div id="section-page-9-1">
                            <Row>
                                <Col md={10}>
                                    <Label className="label-title pb-2">แนบ Memo สำหรับการเสนอลงนาม (Attach Memo For Signing Procedure)<span className="msg-require">*</span></Label>
                                    <SingleUploadfile inputID="memoDoc" folder={validation.values.request_no} dataFile={fileMemoDoc} setDataFile={OnSetFileMemoDoc} isDisable={formIsDisabled} />
                                    { validation.touched.memo_doc && validation.errors.memo_doc ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.memo_doc}</FormFeedback> ) : false 
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="line-border"></div>
                                </Col>
                            </Row>
                        </div>
                    ): null}
                    <div id="section-page-10-1">
                        <Row>
                            <Col md={12}>
                                <span className="span-title">User Approval Process</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup className="pt-3">
                                    <Label className="label-title">ผู้อนุมัติแบบคำขอ (User Approver)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightApproval"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="PopoverRightApproval" >
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดระบุชื่อผู้อนุมัติคำขอ โดยคำขอทุกฉบับต้องได้รับการอนุมัติจากผู้มีตำแหน่ง Director ขึ้นไปในฝ่ายผู้ขอ<br/>Please specify the approver's name. Kindly note that all requests must be approved by director or higher level in your function.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input id="txtApproveRequestBy"
                                        name="approve_request_by"
                                        type="text"
                                        autoComplete={autoCompletes}
                                        className="txt-placeholder"
                                        placeholder="กรุณากรอกอีเมล"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.approve_request_by || ""}
                                        invalid={validation.touched.approve_request_by && validation.errors.approve_request_by ? true : false}
                                        disabled={formIsDisabled || dataFormRequest.request_no !== "draft" && dataUser.email === dataFormRequest.approve_request_by ? true : false}
                                    />
                                    {validation.touched.approve_request_by && validation.errors.approve_request_by ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.approve_request_by}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    { checkShowInputUserCoordinator ? (
                        <Row id="section-page-11-1">
                            <Col md={10}>
                                <FormGroup>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="prCreateRequestBy"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="prCreateRequestBy">
                                            <PopoverBody className="msg-show-hint">
                                                <i className="mdi mdi-help-circle msg-icon-hint"></i> 
                                                โปรดระบุอีเมลของผู้ประสานงานสำหรับคำขอนี้โดยจะต้องเป็นผู้ที่มีรายชื่อเป็นผู้ประสานงานตามที่บริษัทกำหนดและได้แจ้งฝ่ายกฎหมาย BTSG ไว้แล้ว <br/>Please specify the email address of the coordinator for this request. The specified person must be listed as a coordinator as designated by the company and has been informed to BTSG legal team.
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Label className="label-title">ชื่อผู้ประสานงาน (Name of User Coordinator)<span className="msg-require">*</span></Label>
                                    <Input id="txtCreateRequestBy"
                                        name="create_request_by"
                                        type="text"
                                        autoComplete="off"
                                        className="txt-placeholder"
                                        placeholder="กรอกอีเมลผู้ประสานงาน"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true);
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.create_request_by || ""}
                                        invalid={validation.touched.create_request_by && validation.errors.create_request_by ? true : false}
                                        disabled={formIsDisabled || (dataFormRequest.request_no !== "draft" && dataUser.email === dataFormRequest.create_request_by) || (dataFormRequest.id_workflow_status > 4) ? true : false}
                                    />
                                    {validation.touched.create_request_by && validation.errors.create_request_by ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.create_request_by}
                                        </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    ) : null }
                    { showCommentApprover === true || dataFormLdr?.approver_comment !== "" ? (
                        <Row id="section-page-12-1">
                            <Col md={12}>
                                <div className="line-border"></div>
                            </Col>
                            <Col md={10}>
                                <div className="page-content-approver">
                                    <div className="approver-header-content">
                                        {dataUser.email === dataFormRequest.approve_request_by ? "ระบุความเห็นเพื่อส่งไปยังผู้ร้องขอ (Please specify comments to send to the requester.)" : "คุณมีความเห็นจากผู้อนุมัติ (You have a comments from the approver)"}
                                    </div>
                                    <FormGroup>
                                        <Col md={10} className="approver-col">
                                            <Label className="label-title-approver-comment">ความเห็นของผู้อนุมัติ (Approver's Comment)</Label>
                                            <Input
                                                type="text"
                                                id="txtApproveComment"
                                                name="approver_comment"
                                                autoComplete="off"
                                                className="txt-approver-comment"
                                                placeholder="ความเห็นเพิ่มเติมของผู้อนุมัติ"
                                                onChange={(e) => {
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    validationReturn.handleChange(e);
                                                    //setIsSaveEnabled(true);
                                                }}
                                                onBlur={validationReturn.handleBlur}
                                                value={validation.values.approver_comment || ""}
                                                invalid={validationReturn.touched.approver_comment && validationReturn.errors.approver_comment ? true : false}
                                                disabled={(dataUser.email === dataFormRequest.request_by) || (dataUser.email === dataFormRequest.create_request_by) || (dataUser.email === dataFormRequest.approve_request_by && dataFormRequest.id_workflow_status === 4) ? true : false}
                                            />
                                            {validationReturn.touched.approver_comment && validationReturn.errors.approver_comment ? (
                                                <FormFeedback type="invalid" className="alert-validation-approver-comment">
                                                    {validationReturn.errors.approver_comment}
                                                </FormFeedback>
                                            ) : false}
                                        </Col>
                                    </FormGroup>
                                </div>
                            </Col>
                        </Row>
                    ) : null }
                    <div id="section-page-13-1">
                        <Row>
                            <Col md={10}>
                                <Alert className="border-0 border-0 remark-content">
                                    <i className="mdi mdi-alert icon-remark-color"></i><strong className="remark-color"> หมายเหตุ (Remark) </strong><br/>
                                    <span className="span-remark">"User รับทราบว่าแบบฟอร์มนี้เป็นความลับและมีวัตถุประสงค์เพื่อใช้ภายในบริษัทในเครือ BTS Group เท่านั้น หากพนักงานเปิดเผยข้อมูลแบบฟอร์มให้แก่บุคคลภายนอก ถือว่าประพฤติผิดวินัยอย่างร้ายแรง"</span><br/>
                                    <span className="span-remark">"Users are fully aware that this request form is strictly private and confidential for internal use within BTS Group's affiliates only. Any employee disclosing this request form to the third party is considered a serious misconduct."</span>
                                </Alert>
                            </Col>
                        </Row>
                    </div>
                    { // Check if status is 0 or greater
                        ((dataFormRequest.id_workflow_status >= 0 && dataFormRequest.id_workflow_status <= 4) || dataFormLdr.id === 0) 
                        ? (
                            <Row>
                                <div className="page-footer">
                                    <div className="layout-width-footer">
                                        <div className="navbar-footer">
                                            <div className="d-flex align-items-center">
                                                <Link to={GetUrlBack()} className="logo">
                                                    <Button type="button" color="outline secondary" >
                                                        Back
                                                    </Button>
                                                </Link>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                {dataFormRequest.request_no === "draft" ? (
                                                    <Button type="button" color="outline secondary" onClick={() => onCancelRequest(dataFormRequest)} >
                                                        Delete
                                                    </Button>
                                                ): null}
                                                {/* case if requestor && approver ถ้าคนเปิด request และ คนอนุมัติเป็นคนเดียวกันจะปิด ปุ่ม return  */}
                                                {checkUserIsApproverShowReturnBtn === true && checkUserCreateTicketAndApproveIsSame === true ? (
                                                    <Button className="btn-return-style" color="outline secondary" type="button" disabled={isSaveEnabled} onClick={() => onClickCheckReturn()} >
                                                        Return
                                                    </Button>
                                                ) : null}
                                                {changeButtonIsStateRequestorOrApprover ?(
                                                    <>
                                                        <Button 
                                                            className="float-end btn-save-style"  
                                                            color={isSaveEnabled ? "primary" : "secondary"} 
                                                            outline 
                                                            type="button" 
                                                            disabled={!isSaveEnabled}
                                                            onClick={() => onClickCheckSaveDraft()}
                                                        >
                                                            Save
                                                        </Button>
                                                        <Button 
                                                            className="float-end btn-submit-style" 
                                                            color="primary" 
                                                            type="button"
                                                            disabled={dataUser.email === dataFormRequest.approve_request_by ? isSaveEnabled : false}
                                                            onClick={() => { onClickCheckSubmit()}}
                                                        >
                                                            {dataUser.email === dataFormRequest.approve_request_by ? "Approve" : "Submit"}
                                                        </Button>
                                                    </>
                                                ):null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        ): (
                            <div id="footer-modal">
                                <hr className="line-footer"></hr>
                                <Col md={12}>
                                    <Button 
                                        className="float-end btn-submit-style" 
                                        color="primary" 
                                        type="button"
                                        onClick={() => validation.submitForm()}
                                    >
                                        Update
                                    </Button>
                                    <Button 
                                        className="float-end btn-cancel" 
                                        color="outline secondary" 
                                        type="button" 
                                        onClick={() => onCancelRequest(false)}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </div>
                        )
                    }
                </Form>
            </div>
        </React.Fragment>
        );
    };

export default RequestFormLdr;